const en = {
  login: {
    login: 'Log In',
    loginText: 'Please log in to access your Zenhammer dashboard.',
    email: 'Email',
    enterEmail: 'Enter your email',
    writePasword: 'Write your password',
    password: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    sendResetCode: 'Send reset code',
    forgotPasswordMessage: 'Enter your email to receive a reset code',
    signIn: 'Sign In',
    resetPassword: 'Reset Password',
    resetPasswordMessage:
      'Enter the reset code you received and your new password',
    passwordResetCode: 'Password reset code',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    enterPasswordResetCode: 'Enter the password reset code you received',
    writeNewPassword: 'Write a new password',
    confirmNewPassword: 'Confirm the new password',
    passwordsDoNotMatch: 'Passwords do not match',
    enterTempPassword: 'Enter the temporary password you received',
    tempPassword: 'Temporary password',
    confirmUserMessage:
      'Looks like you are doing the initial login, please enter a new password below',
    initialLoginMessage:
      'You should have received the welcome message, please enter the password below',
    // Sprint 28, story-143. Wiring the login/register/reset/force-reset flows into this
    // previously-unconsumed section (docs/ux/story-143-design.md).
    subtitle: 'New here or coming back? Enter your details to continue.',
    changePasswordToContinue: 'Login and change your password to continue',
    enterPassword: 'Enter your password',
    forgotPasswordTitle: 'Forgot password?',
    forgotPasswordSubtitle: 'Enter your email to reset your password.',
    sendResetLink: 'Send reset link',
    resetPasswordTitle: 'Reset Password',
    resetPasswordSubtitle: 'Please enter your new password and confirmation code.',
    enterResetCode: 'Enter the code from the email',
    newPasswordLabel: 'New password',
    confirmPasswordLabel: 'Confirm password',
    confirmNewPasswordPlaceholder: 'Confirm new password',
    resetPasswordSubmit: 'Reset password',
    setNewPasswordTitle: 'Set a new password',
    setNewPasswordSubtitle: 'Please set your new password to continue.',
    saveNewPassword: 'Save new password',
    back: 'Back',
    noAccount: "Don't have an account?",
    signUp: 'Sign up',
    deeplinkUsed:
      'This sign-in link has already been used. Please log in with your password.',
    invalidEmail: 'Invalid email address',
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    codeRequired: 'Code is required',
    confirmPasswordRequired: 'Confirm your password',
    // Sprint 28, story-143. Register form validation (AC4) — the top-level fields; the
    // conditional billing/card sub-schema (requiresCard branch) is a known, flagged residual
    // gap this sprint (see the sprint's develop-run report), not silently dropped.
    firstNameRequired: 'First name is required',
    firstNameMinLength: 'First name must be at least 2 characters',
    lastNameRequired: 'Last name is required',
    lastNameMinLength: 'Last name must be at least 2 characters',
    selectOption: 'Please select an option',
    selectHowToGetStarted: 'Please select how you would like to get started',
    organizationNameRequired: 'Organization name is required',
    organizationNameMinLength: 'Organization name must be at least 2 characters',
    selectPlanToContinue: 'Select a plan to continue',
    // Sprint 28, develop run 3 (story-143 review Warning #2 fix). Card-required registration
    // (`requiresCard` branch of `schemaValidations.ts`) — previously the one flagged, honest
    // AC4 gap; `firstNameRequired`/`lastNameRequired`/`invalidEmail`/`emailRequired` above are
    // reused for the matching billing-contact fields rather than duplicated.
    billingPeriodRequired: 'Select a billing period',
    billingAddressRequired: 'Address is required',
    billingCityRequired: 'City is required',
    billingStateFormat: 'State must be 2 letters (e.g., CA)',
    billingStateRequired: 'State is required',
    billingZipRequired: 'ZIP code is required',
    cardNumberRequired: 'Card number is required',
    cardNumberInvalid: 'Invalid card number',
    cardExpirationRequired: 'Expiration date is required',
    cardExpirationFormat: 'Format must be MM/YY',
    cardExpired: 'Card has expired',
    cvvRequired: 'CVV is required',
    cvvFormat: 'CVV must be 3 or 4 digits',
    registrationFailed: 'Registration failed. Please try again.',
    registrationError: 'Registration Error',
    unexpectedError: 'An unexpected error occurred. Please try again.',
    // AccountExists — the two "this email is taken" screens.
    alreadyHaveAccount: 'You already have an account',
    accountAlreadyExists: 'Account Already Exists',
    accountRegisteredExplain:
      'This email address already has a ZenHammer account. Sign up is only for new accounts — additional organizations are created from inside the app.',
    toCreateAnotherOrg: 'To create another organization',
    accountExistsStep1: 'Sign in with this email',
    accountExistsStep2: 'Open your Profile page',
    accountExistsStep3: 'Choose "Create Organization"',
    accountInvitedExplain:
      'This email address is already registered in our system. You were previously invited to join an organization.',
    whatShouldIDo: 'What should I do?',
    checkInboxForInvite: 'Check your email inbox for an invitation email',
    checkSpamFolder: 'Look in your spam/junk folder',
    useForgotPasswordHint: 'Use "Forgot Password" if you need to reset your credentials',
    goToLogin: 'Go to Login',
    forgotPasswordButton: 'Forgot Password',
    useDifferentEmail: 'Use a different email address',
    noInvitationFoundTitle: 'No Invitation Found',
    noInvitationFoundFor: "We couldn't find an invitation for {email}",
    checkEmailOrCreateOrg:
      'Please check your email for an invitation link, or create your own organization to get started.',
    createAnOrganizationButton: 'Create an Organization',
    orWaitForInvitation: 'or wait for an invitation email',
    whatsNext: "What's next?",
    whatsNextDetail:
      "If you're expecting an invitation, please check your email inbox and spam folder. If you want to start using Zenhammer right away, you can create your own organization.",
    couldNotLoadPlans: 'Could not load plans',
    couldNotLoadPlansMessage:
      'We could not load the available subscription plans. Please refresh the page and try again.',
    noPlansAvailable: 'No plans available',
    noPlansAvailableMessage:
      'No subscription plans are currently available, so a new organization cannot be created right now. Please contact support.',
    yourPlan: 'Your plan',
    chooseYourPlan: 'Choose your plan',
    yourPlanStartHint: 'This is what your organization will start on.',
    choosePlanHint:
      'Pick the plan your organization will start on. Trial length and whether a card is needed up front differ per plan.',
    selectYourPlan: 'Select Your Plan',
    createAccount: 'Create Account',
    creatingAccount: 'Creating Account...',
    createAccountAndStartTrial: 'Create Account & Start Trial',
    createYourAccount: 'Create your account',
    joinAndManage: 'Join Zenhammer and start managing your construction projects',
    alreadyHaveAccountQuestion: 'Already have an account?',
    personalInformation: 'Personal Information',
    firstNameLabel: 'First Name',
    lastNameLabel: 'Last Name',
    firstNamePlaceholder: 'Enter your first name',
    lastNamePlaceholder: 'Enter your last name',
    confirmYourPassword: 'Confirm your password',
    organizationInformation: 'Organization Information',
    organizationNameLabel: 'Organization Name',
    organizationNamePlaceholder: 'Enter your organization name',
    howWouldYouLikeToStart: 'How would you like to get started?',
    invitedOptionTitle: 'I was invited to join an organization',
    invitedOptionDesc:
      "You received an email invitation to join your company's Zenhammer workspace. Complete your registration to access your team's projects.",
    noPaymentRequired: 'No payment required',
    createOptionTitle: 'I want to create a new organization',
    createOptionDesc:
      "Start your own Zenhammer workspace for your company. You'll set up billing and invite your team members.",
    choosePlanNext: 'Choose your plan next',
    continueButton: 'Continue',
    paymentDetailsStep: 'Payment details',
    planRequiresCard: 'The {plan} plan requires a card to start.',
    planStepTitle: 'Plan',
    personalInfoStepTitle: 'Personal Info',
    organizationStepTitle: 'Organization',
    paymentStepTitle: 'Payment',
    trialPlanSummary: 'Your organization starts on a {days}-day free trial of {plan}.',
    billedImmediatelyPlanSummary: 'Your organization starts on {plan}, billed immediately.',
    noCardRequiredHint:
      "No credit card required — we'll ask for payment details when the trial ends.",
    cardRequiredHint: 'A credit card is required to complete sign-up.',
    paymentMethodLabel: 'Payment Method',
    creditOrDebitCard: 'Credit or Debit Card',
    cardBrandsHint: 'Visa, Mastercard, Amex, Discover',
    billingInformation: 'Billing Information',
    address: 'Address',
    city: 'City',
    state: 'State',
    zipCode: 'ZIP Code',
    phone: 'Phone',
    cardInformation: 'Card Information',
    cardNumber: 'Card Number',
    expirationDate: 'Expiration (MM/YY)',
    cvv: 'CVV',
    paymentSecureHint:
      'Your payment information is securely tokenized and encrypted. Card details are never stored on our servers.',
  },
  //TODO: I would refactor these using element + action to avoid so much repetition
  actionMessages: {
    // Sprint 31, story-160/161. Project wizard + AI plan generation.
    planImportedSuccessfully: 'Plan imported successfully',
    templateImportFailedAfterCreate: "Couldn't import the template's tasks. You can import one from the schedule page.",
    planSavedAsTemplate: 'Plan saved as template',
    planGenerationFailed: "Couldn't generate the plan",
    deleteSuccessful: 'Delete successful',
    updateSuccessful: 'Update successful',
    profileUpdatedSuccessfully: 'Profile updated successfully',
    organizationCreatedSuccessfully: 'Organization created successfully',
    organizationEditedSuccessfully: 'Organization edited successfully',
    organizationEnabledSuccessfully: 'Organization enabled successfully',
    organizationDisabledSuccessfully: 'Organization deleted successfully',
    userCreatedSuccessfully: 'User created successfully',
    userEditedSuccessfully: 'User edited successfully',
    userDisabledSuccessfully: 'User deleted successfully',
    userEnabledSuccessfully: 'User enabled successfully',
    loginNoEmail:
      'No email, enter your email and click "Forgot password" again',
    // Sprint 31, develop run 3 (Priority 1). ALL toast/alert copy, deduped across call sites.
    // Auth & session
    checkYourCredentials: 'Check your credentials',
    // Sprint 52, story-265. Specific sign-in failure copy per backend errorCode.
    loginPasswordResetRequired: 'Your password must be reset. Click "Forgot password" to choose a new one.',
    loginUserNotConfirmed: 'Your account is not confirmed yet. Check your email for the setup link.',
    loginTempPasswordExpired: 'Your temporary password has expired. Click "Forgot password" to get a new setup link.',
    loginTooManyAttempts: 'Too many sign-in attempts. Please wait a few minutes and try again.',
    loginCouldNotReachServer: 'Could not reach the server. Check your connection and try again.',
    invalidVerificationCode: 'Invalid verification code provided, please try again.',
    loggedInSuccessfully: 'Logged in successfully',
    passwordChangeSuccessful: 'Password change successful',
    passwordResetSuccessfully: 'Password reset successfully',
    passwordSetSuccessfully: 'Password set successfully',
    passwordUpdatedSuccessfully: 'Password updated successfully',
    pleaseChangeYourPassword: 'Please change your password',
    sessionExpiredSignInAgain: 'Session expired. Please sign in again.',
    // Billing & subscriptions
    addonAddedSuccessfully: 'Addon added successfully',
    addonRemovedSuccessfully: 'Addon removed successfully',
    askAdminToAddSeats: 'Ask your owner or admin to add seats.',
    defaultPaymentMethodUpdatedSuccessfully: 'Default payment method updated successfully',
    paymentAccountConnected: 'Payment account connected',
    paymentAccountRemoved: 'Payment account removed',
    paymentMethodAddedSuccessfully: 'Payment method added successfully',
    paymentMethodDeletedSuccessfully: 'Payment method deleted successfully',
    planAssignedSuccessfully: 'Plan assigned successfully',
    trialExtendedSuccessfully: 'Free period extended',
    subscriptionActiveFullAccessRestored: 'Your subscription is active. Full access restored.',
    subscriptionPausedSuccessfully: 'Subscription paused successfully',
    subscriptionPlanCreatedSuccessfully: 'Subscription plan created successfully',
    subscriptionPlanDeletedSuccessfully: 'Subscription plan deleted successfully',
    subscriptionPlanUpdatedSuccessfully: 'Subscription plan updated successfully',
    subscriptionReactivatedSuccessfully: 'Subscription reactivated successfully!',
    subscriptionResumedSuccessfully: 'Subscription resumed successfully',
    subscriptionStartedSuccessfully: 'Subscription started successfully! Billing will begin on your next billing date.',
    // Budgets & line items
    budgetProposalAcceptedSuccessfully: 'Budget proposal accepted successfully',
    budgetProposalRejected: 'Budget proposal rejected',
    budgetProposalSubmittedSuccessfully: 'Budget proposal submitted successfully',
    budgetRequestAcceptedSuccessfully: 'Budget request accepted successfully',
    budgetRequestCancelled: 'Budget request cancelled',
    budgetRequestCreatedSuccessfully: 'Budget request created successfully',
    budgetRequestRejected: 'Budget request rejected',
    counterProposalSubmittedSuccessfully: 'Counter proposal submitted successfully',
    lineItemCreatedSuccessfully: 'Line item created successfully',
    lineItemDeleted: 'Line item deleted',
    lineItemUpdated: 'Line item updated',
    // Categories
    categoryCreatedSuccessfully: 'Category created successfully',
    categoryDeletedSuccessfully: 'Category deleted successfully',
    categoryUpdatedSuccessfully: 'Category updated successfully',
    failedToDeleteCategory: 'Failed to delete category',
    failedToDelete: 'Failed to delete',
    failedToSaveCategory: 'Failed to save category',
    // Clients
    clientCreatedInvitationFailed: 'Client created, but the invitation could not be sent. Retry it from the Client access tab.',
    clientCreatedSuccessfully: 'Client created successfully',
    clientDeletedSuccessfully: 'Client deleted successfully',
    clientUpdatedSuccessfully: 'Client updated successfully',
    noClientWasDeleted: 'No client was deleted',
    // Crews & employees
    crewCreatedSuccessfully: 'Crew created successfully',
    crewDeletedSuccessfully: 'Crew deleted successfully',
    crewMembersUpdatedSuccessfully: 'Crew members updated successfully',
    crewTasksUpdatedSuccessfully: 'Crew tasks updated successfully',
    crewUpdatedSuccessfully: 'Crew updated successfully',
    employeeUnassignedSuccessfully: 'Employee unassigned successfully',
    errorFetchingCrew: 'Error fetching crew',
    // Documents
    documentDeletedSuccessfully: 'Document deleted successfully',
    documentUpdatedSuccessfully: 'Document updated successfully',
    documentUploadedSuccessfully: 'Document uploaded successfully',
    failedToDeleteDocument: 'Failed to delete document',
    // Geofences
    geofenceCreated: 'Geofence created',
    geofenceUpdated: 'Geofence updated',
    failedToSaveGeofence: 'Failed to save geofence',
    failedToUpdateStatus: 'Failed to update status',
    // Incidents
    incidentAcknowledgedSuccessfully: 'Incident acknowledged successfully',
    // Invoices
    connectPaymentAccountToResend: 'Connect a payment account before resending this invoice.',
    connectPaymentAccountToSend: 'Connect a payment account before sending this invoice.',
    invoiceSent: 'Invoice sent',
    invoiceVoided: 'Invoice voided',
    // Misc
    couldNotCopyLink: 'Could not copy the link',
    delegationCancelledSuccessfully: 'Delegation cancelled successfully',
    draftDeleted: 'Draft deleted',
    emailIsRequired: 'Email is required',
    errorFetchingActivities: 'Error fetching activities',
    failedToMoveReservation: 'Failed to move reservation',
    failedToResizeReservation: 'Failed to resize reservation',
    failedToSetMaintenanceStatus: 'Failed to set maintenance status',
    noInvitationFoundForEmail: 'No invitation found for this email address.',
    registrationSuccessfulWelcome: 'Registration successful! Welcome to Zenhammer.',
    registrationFailed: 'Registration failed',
    reservationMovedSuccessfully: 'Reservation moved successfully',
    reservationUpdatedSuccessfully: 'Reservation updated successfully',
    // Notification recipients
    recipientAdded: 'Recipient added',
    recipientDeleted: 'Recipient deleted',
    recipientUpdated: 'Recipient updated',
    // Organizations
    defaultOrganizationUpdatedSuccessfully: 'Default organization updated successfully',
    failedToCheckOrganizationStatus: 'Failed to check organization status',
    organizationActiveRedirecting: 'Organization is active! Redirecting...',
    organizationCreatedRedirecting: 'Organization created successfully! Redirecting...',
    organizationCreatedTrialStarts: 'Organization created. Your free trial starts now.',
    organizationStillSuspended: 'Organization is still suspended.',
    organizationUpdatedSuccessfully: 'Organization updated successfully',
    // Projects
    errorFetchingProjectBudgetSummary: 'Error fetching project budget summary',
    noProjectSelectedReopen: 'No project selected. Please reopen the project and try again.',
    noProjectWasDeleted: 'No project was deleted',
    projectCreatedSuccessfully: 'Project created successfully',
    projectDeletedSuccessfully: 'Project deleted successfully',
    projectIdCopiedToClipboard: 'Project ID copied to clipboard',
    projectStatusUpdatedSuccessfully: 'Project status updated successfully',
    projectUpdatedSuccessfully: 'Project updated successfully',
    // Tasks
    subtaskCreatedSuccessfully: 'Subtask created successfully',
    taskCreatedSuccessfully: 'Task created successfully',
    tasksImportedSuccessfully: 'Tasks imported successfully',
    taskTemplateCreatedSuccessfully: 'Task template created successfully',
    taskTemplateDeletedSuccessfully: 'Task template deleted successfully',
    taskUpdatedSuccessfully: 'Task updated successfully',
    // Users & settings
    avatarUpdatedSuccessfully: 'Avatar updated successfully',
    errorLoadingUserData: 'Error loading user data',
    minimumVersionUpdatedSuccessfully: 'Minimum version updated successfully',
    roleIsRequired: 'Role is required',
    roleUpdatedSuccessfully: 'Role updated successfully',
    settingCreatedSuccessfully: 'Setting created successfully',
    settingDeletedSuccessfully: 'Setting deleted successfully',
    settingUpdatedSuccessfully: 'Setting updated successfully',
    userStatusUpdatedSuccessfully: 'User status updated successfully',
    userUpdatedSuccessfully: 'User updated successfully',
    // Warehouse, materials & equipment
    assetAssignedToEquipment: 'Asset assigned to equipment',
    defaultWarehouseUpdatedSuccessfully: 'Default warehouse updated successfully',
    equipmentAddedFromWarehouse: 'Equipment added from warehouse',
    equipmentAddedManually: 'Equipment added manually',
    equipmentAssetCodeExists: 'An equipment with this asset code already exists. Please use a different code.',
    equipmentAssetsExportedSuccessfully: 'Equipment assets exported successfully',
    equipmentCheckedOut: 'Equipment checked out',
    equipmentCheckedOutSuccessfully: 'Equipment checked out successfully',
    equipmentCreatedSuccessfully: 'Equipment created successfully',
    equipmentDeletedSuccessfully: 'Equipment deleted successfully',
    equipmentNameExists: 'An equipment with this name already exists. Please use a different name.',
    equipmentRemoved: 'Equipment removed',
    equipmentReturned: 'Equipment returned',
    equipmentReturnedSuccessfully: 'Equipment returned successfully',
    equipmentSetToMaintenance: 'Equipment set to maintenance',
    equipmentUpdated: 'Equipment updated',
    equipmentUpdatedSuccessfully: 'Equipment updated successfully',
    errorFetchingMaterialsAndEquipment: 'Error fetching materials and equipments',
    failedToCheckoutEquipment: 'Failed to checkout equipment',
    failedToDeleteEquipment: 'Failed to delete equipment',
    failedToDeleteMaterial: 'Failed to delete material',
    failedToExportEquipmentAssets: 'Failed to export equipment assets',
    failedToExportMaterialCatalog: 'Failed to export material catalog',
    failedToExportTransactionHistory: 'Failed to export transaction history',
    failedToReturnEquipment: 'Failed to return equipment',
    failedToSaveEquipment: 'Failed to save equipment. Please try again.',
    failedToSaveMaterial: 'Failed to save material',
    materialAddedFromWarehouse: 'Material added from warehouse',
    materialCatalogExportedSuccessfully: 'Material catalog exported successfully',
    materialCreatedInitialStockFailed: 'Material created, but failed to add initial stock',
    materialCreatedSuccessfully: 'Material created successfully',
    materialCreatedWithInitialStock: 'Material created with initial stock',
    materialDeletedSuccessfully: 'Material deleted successfully',
    materialMarkedAsConsumed: 'Material marked as consumed',
    materialRemoved: 'Material removed',
    materialReservedFromWarehouse: 'Material reserved from warehouse',
    materialReturnedToWarehouse: 'Material returned to warehouse',
    materialUpdated: 'Material updated',
    materialUpdatedSuccessfully: 'Material updated successfully',
    plannedEquipmentAdded: 'Planned equipment added',
    plannedMaterialAdded: 'Planned material added',
    stockAdjustedSuccessfully: 'Stock adjusted successfully',
    transactionHistoryExportedSuccessfully: 'Transaction history exported successfully',
    warehouseCreatedSuccessfully: 'Warehouse created successfully',
    warehouseDeletedSuccessfully: 'Warehouse deleted successfully',
    warehouseUpdatedSuccessfully: 'Warehouse updated successfully',
    // Sprint 31, develop run 3 (Priority 1 follow-up). Toast/Alert fallback literals
    // (guard-invisible: the toast/Alert arg was a `||`/ternary chain, not a bare string).
    // Billing & subscriptions
    couldNotActivateSubscription: 'Could not activate the subscription.',
    failedToAddAddon: 'Failed to add addon',
    failedToAddPaymentMethod: 'Failed to add payment method',
    failedToAssignPlan: 'Failed to assign plan',
    failedToExtendTrial: 'Failed to extend free period',
    failedToCancelSubscription: 'Failed to cancel subscription',
    failedToDeletePaymentMethod: 'Failed to delete payment method',
    failedToLinkAddon: 'Failed to link add-on',
    failedToPauseSubscription: 'Failed to pause subscription',
    failedToRepriceAddon: 'Failed to reprice add-on',
    failedToResumeSubscription: 'Failed to resume subscription',
    failedToStartSubscription: 'Failed to start subscription',
    failedToUnlinkAddon: 'Failed to unlink add-on',
    failedToUpdateDefaultPaymentMethod: 'Failed to update default payment method',
    // Budgets & line items
    errorCreatingLineItem: 'Error creating line item',
    errorDeletingLineItem: 'Error deleting line item',
    errorUpdatingLineItem: 'Error updating line item',
    // Clients
    clientAccessUpdated: 'Client access updated',
    failedToDeleteClient: 'Failed to delete client',
    // Crews
    failedToDeleteCrew: 'Failed to delete crew',
    // Geofences
    geofenceDisabled: 'Geofence disabled',
    failedToUpdateGeofence: 'Failed to update geofence',
    geofenceEnabled: 'Geofence enabled',
    // Incidents
    failedToReportIncident: 'Failed to report incident',
    incidentReportedSuccessfully: 'Incident reported successfully',
    // Misc
    failedToImportTasksFromTemplate: 'Failed to import tasks from template',
    invitationResent: 'Invitation resent.',
    invitationSent: 'Invitation sent.',
    requestError: 'Request error',
    // Notification recipients
    recipientDisabled: 'Recipient disabled',
    recipientEnabled: 'Recipient enabled',
    // Field Capture admin (sprint 31, orchestrator scope reversal — see i18n-scope-rules.md §7)
    failedToRegenerateLinks: 'Failed to regenerate links',
    linksAlreadyUpToDate: 'Links already up to date',
    uploadFailed: 'Upload failed',
    batchApplied: 'Batch applied — store links regenerated',
    applyFailed: 'Apply failed',
    batchDiscarded: 'Batch discarded',
    discardFailed: 'Discard failed',
    projectLinkedToStore: 'Project linked to every terminal at this store',
    projectUnlinked: 'Project unlinked',
    failedToLinkProject: 'Failed to link project',
    submissionResolvedAndProcessed: 'Submission resolved and processed',
    failedToResolveSubmission: 'Failed to resolve submission',
    exportFailed: 'Export failed',
    ocrRunFailed: 'OCR run failed',
    couldNotResolveSerial: 'Could not resolve the serial',
    // Organizations
    couldNotCreateOrganization: 'Could not create the organization.',
    invoicingPausedForOrganization: 'Invoicing paused for organization',
    invoicingResumedForOrganization: 'Invoicing resumed for organization',
    organizationDisabledStatusSuccessfully: 'Organization disabled successfully',
    // Projects
    failedToDeleteProject: 'Failed to delete project',
    // Task templates
    failedToCreateTaskTemplate: 'Failed to create task template',
    failedToDeleteTaskTemplate: 'Failed to delete task template',
    // Users
    userDisabledStatusSuccessfully: 'User disabled successfully',
  },
  menu: {
    dashboard: 'Dashboard',
    mapView: 'Map View',
    clients: 'Clients',
    employees: 'Employees',
    crews: 'Crews',
    subcontractors: 'Subcontractors',
    projects: 'Projects',
    inventory: 'Inventory',
    reports: 'Reports',
    invoices: 'Invoices',
    schedule: 'Schedule',
    permits: 'Permits',
    insurance: 'Insurance',
    organizations: 'Organizations',
    settings: 'Settings',
    logout: 'Logout',
    users: 'Users',
    searchResultsMinLength: 'Type at least three characters',
    // Sprint 28, story-142. Remaining sidebar/admin nav items — docs/ux/story-142-design.md.
    documents: 'Documents',
    templates: 'Templates',
    incidents: 'Incidents',
    warehouse: 'Warehouse',
    geofences: 'Geofences',
    billing: 'Billing',
    bids: 'Bids',
    subscriptionPlans: 'Subscription Plans',
    userAdmin: 'User Admin',
    warehouseConfig: 'Warehouse Config',
    notificationRecipients: 'Notification Recipients',
    createInvoice: 'Create Invoice',
    fieldCapture: 'Field Capture',
    platformStatus: 'Platform Status',
    tutorials: 'Tutorials',
    uiComponents: 'UI Components',
    assistant: 'Assistant',
    dailyReports: 'Daily reports',
  },
  settings: {
    changeAvatar: 'Change Avatar',
    saveAvatar: 'Save Avatar',
    changePassword: 'Change Password',
    oldPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    updatePassword: 'Update Password',
    saveName: 'Save Name',
    saveLanguage: 'Save Language',
    english: 'English',
    spanish: 'Spanish',
    // Sprint 27, story-139. Language switcher save feedback (docs/ux/story-139-design.md, Flow A).
    language: 'Language',
    languageUpdated: 'Language updated',
    languageUpdateError: 'Could not update language. Please try again.',
    // Sprint 28, story-142. "In progress" tier (15-65%) — docs/ux/i18n-house-style.md §7. Both
    // this sprint's floors land in this tier even at story-145's most optimistic outcome.
    autoDetectHint:
      "We're translating ZenHammer into Spanish. You'll still see some screens in English until we finish.",
    autoDetectHintGotIt: 'Got it',
    autoDetectBanner: "We set ZenHammer to {language} based on your device. You can change it anytime in your Profile.",
    // Sprint 28, story-142. Profile/Settings page chrome — docs/ux/story-142-design.md Wireframe C.
    profileTitle: 'User Profile',
    firstName: 'First Name',
    lastName: 'Last Name',
    enterFirstName: 'Enter first name',
    enterLastName: 'Enter last name',
    enterOldPassword: 'Enter old password',
    enterNewPassword: 'Enter new password',
    updatePasswordButton: 'Update password',
    myOrganizations: 'My Organizations',
    myOrganizationsHint: 'Manage and switch between your organizations',
    createOrganization: 'Create Organization',
    createFirstOrganization: 'Create Your First Organization',
    noOrganizationsYet: "You don't have any organizations yet",
    minVersion: 'Minimum Version',
    minVersionPlaceholder: 'e.g. 1.2.3',
    updateMinVersion: 'Update Minimum Version',
    createMinVersion: 'Create Minimum Version',
    minVersionDescription: 'Description',
    minVersionDescriptionPlaceholder: 'Description for minimum version setting',
    settingsTitle: 'Settings',
    enterEmailPlaceholder: 'Enter email',
    // Sprint 28, story-142. settings/warehouse — org-level warehouse category defaults (distinct
    // from story-145's warehouse feature screens, see docs/architecture.md "## Sprint 28").
    warehouseBreadcrumb: 'Warehouse',
    categoriesBreadcrumb: 'Categories',
    materialEquipmentCategories: 'Material & Equipment Categories',
    addCategory: 'Add Category',
    organizationCategories: 'Organization Categories',
    organizationCategoriesHint:
      'These categories are specific to your organization. You can customize them to match your workflow.',
    materialCategoriesTab: 'Material Categories ({n})',
    equipmentCategoriesTab: 'Equipment Categories ({n})',
    searchCategoriesPlaceholder: 'Search categories...',
    materialAndEquipment: 'Material & Equipment',
    totalCategories: 'Total Categories',
    deleteCategory: 'Delete Category',
    confirmDeleteCategory:
      'Are you sure you want to delete "{name}"? This action cannot be undone.',
    categoryUpdated: 'Category updated successfully',
    categoryCreated: 'Category created successfully',
    categorySaveError: 'Failed to save category',
    categoryDeleted: 'Category deleted successfully',
    categoryDeleteError: 'Failed to delete category',
  },
  common: {
    // Sprint 40, story-215. Plan list error panel.
    retry: 'Retry',
    couldNotLoadSubscriptionPlans: 'Could not load subscription plans',
    createdSuccessfully: 'Created successfully',
    updatedSuccessfully: 'Updated successfully',
    deletedSuccessfully: 'Deleted successfully',
    // Sprint 29 (Addendum 11 fix). `TaskAndEventTable/index.tsx:128,157` read `common.success`,
    // which never existed — the `|| 'English'` fallback was silently load-bearing on every
    // approve/reject. Two specific keys, not one generic `success`, since the two call sites want
    // different messages.
    taskApprovedSuccessfully: 'Task approved successfully',
    taskRejectedSuccessfully: 'Task rejected successfully',
    // Sprint 29, story-148. Shared catalog "unknown" fallback for the new exhaustive enum maps
    // below (`enumLabels`) — same house pattern as `taskDetail.statusUnknown` (Addendum 5:
    // exhaustive switch/Record, `default` returns a catalog string, never `.replace()`), reused
    // here since these enums aren't task-status-specific.
    unknown: 'Unknown',
    // Sprint 31, story-160. Interpolated step-progress label for the project wizard.
    wizardStepOf: 'Step {n} of {total}',
    action: 'Action',
    actions: 'Actions',
    active: 'Active',
    add: 'Add',
    alert: 'Alert',
    all: 'All',
    back: 'Back',
    cancel: 'Cancel',
    cannotDelete: 'Cannot delete if there are related entities',
    clickDelete: 'Click here to delete',
    clickEdit: 'Click here to edit',
    clickShowDoc: 'Click to show in google docs',
    clickView: 'Click here to view',
    close: 'Close',
    collapse: 'Collapse',
    color: 'Color',
    confirm: 'Confirm',
    create: 'Create',
    custom: 'Custom',
    delete: 'Delete',
    deleted: 'Deleted',
    description: 'Description',
    disable: 'Disable',
    disabled: 'Disabled',
    documents: 'Documents',
    edit: 'Edit',
    saveChanges: 'Save Changes',
    email: 'Email',
    enable: 'Enable',
    end: 'End',
    expand: 'Expand',
    export: 'Export',
    import: 'Import',
    name: 'Name',
    none: 'None',
    notNow: 'Not Now',
    openDrawer: 'Open Drawer',
    optional: 'Optional',
    options: 'Options',
    organization: 'Organization',
    owner: 'Owner',
    preview: 'Preview',
    requestError: 'Network request failed',
    somethingWentWrong: 'Something went wrong, please refresh and try again.',
    save: 'Save',
    show: 'Show',
    step: 'Step',
    submit: 'Submit',
    triggers: 'Triggers',
    update: 'Update',
    user: 'User',
    yes: 'Yes',
    first: 'First',
    second: 'Second',
    third: 'Third',
    fourth: 'Fourth',
    last: 'Last',
    // Sprint 28, story-142. New common.* keys — docs/ux/i18n-house-style.md §4/§6.
    status: 'Status',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    previous: 'Previous',
    next: 'Next',
    showingResults: 'Showing {page} to {take} of {total} results',
    paginationLabel: 'Pagination',
    noResults: 'No data available',
    confirmActionTitle: 'Confirm Action',
    confirmActionDescription: 'Are you sure you want to proceed with this action?',
    rows: 'Rows',
    showingRange: 'Showing {from}–{to} of {total}',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    pageNumber: 'Page {n}',
    trialEndedReadOnly: 'Trial ended — read only',
    goToBillingAddPaymentMethod: 'Go to Billing to add a payment method',
    inactive: 'Inactive',
    // Sprint 30, story-152.
    quantity: 'Quantity',
    category: 'Category',
  },
  organizations: {
    title: 'Organizations',
    organization: 'Organization',
    ownersNames: 'Owners Names',
    ownersEmails: 'Owners Emails',
    addOrganization: 'Add Organization',
    create: 'Create',
    enableOrganization: 'Enable Organization',
    disableOrganization: 'Disable Organization',
    confirmDisableMessage:
      'Are you sure that you want to disable the organization?',
    confirmEnableMessage:
      'Are you sure that you want to enable the organization?',
    subscriptionColumn: 'Subscription',
    billingColumn: 'Billing',
    subscriptionFilterAll: 'All subscriptions',
    subscriptionFilterLabel: 'Subscription',
    stateEnabled: 'Enabled',
    stateSuspended: 'Suspended',
    stateDisabled: 'Disabled',
    noSubscription: 'No subscription',
    trialEndsLine: 'Ends {date} ({n} days left)',
    trialEndsLineOneDay: 'Ends {date} (1 day left)',
    trialEndsLineToday: 'Ends {date} (ends today)',
    trialExpiredLine: 'Expired on {date}',
    billingNmi: 'NMI billing',
    billingFreeAdmin: 'Free (admin)',
    billingCardNotStarted: 'Card on file, not started',
    billingNoCard: 'No card',
    billingNmiTooltip: 'NMI owns the billing clock for this organization',
    billingFreeAdminTooltip:
      'Active with no NMI subscription: it will never be charged',
    billingCardNotStartedTooltip:
      'A card is saved but no NMI subscription has been started',
    billingNoCardTooltip: 'No payment method saved',
    extendFreePeriod: 'Extend free period',
    noOrganizationsMatchOnPage:
      'No organizations on this page match the subscription filter.',
    noOrganizationsMatch: 'No organizations match the current filters.',
    clearFilters: 'Clear filters',
    currentStatus: 'Current status',
    extendDateLabel: 'New free period end date',
    extendHelper:
      'Access is restored immediately and ends on this date unless the organization starts paid billing.',
    extendInfo:
      "This does not contact NMI or change the organization's Enabled/Disabled state.",
    extendFreeAdminNote:
      'Free (admin): no end date today. Extending turns this into a bounded free period.',
    extendNmiReason:
      'Billing for this organization is managed by NMI, so its free period cannot be extended here.',
    extendInvalidDate: 'Choose a date after today.',
    assignNoteNmi:
      'This organization is billed through NMI. Assigning a plan here only changes the plan on our side; NMI keeps charging the old plan price, so the two can drift apart. Change the plan in NMI as well.',
    assignNoteTrialExpired:
      'Assigning a plan does not restore access. Use Extend free period to give this organization more time.',
    assignNoteDefault:
      'Note: This is an administrative assignment and will NOT create any charges or affect billing in the payment system.',
    assignPlanTitle: 'Assign Plan',
    assignConfirm: 'Assign',
    currentPlan: 'Current plan:',
    selectPlanLabel: 'Select Plan',
    selectPlanPlaceholder: 'Select a plan...',
    billingPeriodLabel: 'Billing Period',
    billingPeriodMonthly: 'Monthly',
    billingPeriodAnnual: 'Annual',
    planDetails: 'Plan Details',
    planPrice: 'Price: {price}/month',
    planIncludedSeats: 'Included Seats: {n}',
    planAnnualTotal: 'Annual total: {total}/year',
    searchPlaceholder: 'Search organizations...',
    pauseInvoicing: 'Pause invoicing',
    resumeInvoicing: 'Resume invoicing',
    clearSelection: 'Clear',
    selectAllOnPage: 'Select all organizations on this page',
    owners: 'Owners',
    subcontractor: 'Subcontractor',
    atav: 'ATAV',
    plan: 'Plan',
    state: 'State',
    noOwners: 'No owners',
    showAsSubcontractor: 'Show as subcontractor',
    atavEnabled: 'ATAV field capture enabled',
    assignPlan: 'Assign plan',
    invoicingPaused: 'Invoicing paused',
    editOrganization: 'Edit organization',
    disableOrganizationAction: 'Disable organization',
    enableOrganizationAction: 'Enable organization',
    pageRange: '{range} of {count}',
    pauseInvoicingTitle: 'Pause Invoicing',
    resumeInvoicingTitle: 'Resume Invoicing',
    pause: 'Pause',
    resume: 'Resume',
    enableOrganizationsTitle: 'Enable Organizations',
    disableOrganizationsTitle: 'Disable Organizations',
    enableAll: 'Enable all',
    disableAll: 'Disable all',
    userInformation: 'User Information',
  },
  users: {
    title: 'Users',
    role: 'Role',
    firstName: 'First Name',
    status: 'Status',
    lastName: 'Last Name',
    addUser: 'Add User',
    disableUser: 'Disable User',
    editUser: 'Edit User',
    confirmDisableMessage: 'Are you sure that you want to disable the user?',
    confirmEnableMessage: 'Are you sure that you want to enable the user?',
    notAllowedToEdit: 'You are not allowed to edit this user',
    locale: 'Locale',
  },
  clients: {
    client: 'Client',
    addClient: 'Add New Client',
    name: 'Name',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    phoneErrorMessage: 'Invalid phone format',
    emailErrorMessage: 'Invalid email format',
    addressErrorMessage: 'The address must be at least 3 characters long',
    nameErrorMessage: 'Name must be at least 3 characters long',
    // Sprint 25, story-128 (run 5). CLIENT invite-on-create, resend/replace/remove login, and
    // the least-exposure access checklist. See docs/ux/story-128-design.md.
    // Sprint 47, story-235. Conditional notice that replaces the always-on footnote.
    emailInviteNotice:
      "We'll email an invitation to {email} when you save. They join ZenHammer as a Client: view-only access to this client's projects.",
    emailInviteNoticeReplace:
      "Saving will invite {email} as this client's login. The previous login for this client is replaced.",
    createdInvited: 'Client created. Invitation sent to {email}.',
    createdLinked:
      'Client created. {email} already has a ZenHammer login and now has client access to these projects.',
    emailAlreadyMember:
      '{email} is already a member of your organization with a different role. Use a different email, or add them as a Reviewer on the project instead.',
    emailAlreadyClientUser:
      '{email} is already the client user for another client in your organization. One login per client — add the extra contact as a Reviewer instead.',
    accessTab: 'Client access',
    // Sprint 52, story-269. Active/Past split of a client's projects.
    activeProjectsTab: 'Active Projects',
    pastProjectsTab: 'Past Projects',
    noActiveProjectsYet: 'No Active Projects Yet',
    noPastProjectsYet: 'No Past Projects',
    loginStatus: 'Client login',
    loginStatusInvited: 'Invited · not yet signed in',
    loginStatusActive: 'Active · last sign-in {date}',
    loginStatusNone: 'No client login — add an email to invite',
    invite: 'Invite',
    resendInvite: 'Resend invitation',
    inviteResent: 'Invitation resent.',
    removeAccess: 'Remove access',
    replaceLoginTitle: 'Replace the client login?',
    replaceLoginBody: '{email} currently has client access. Choose what happens.',
    keepCurrentLogin: 'Keep current login',
    replaceLogin: 'Replace login',
    removeLoginTitle: 'Remove client login?',
    removeLoginBody: '{email} will lose access to these projects. The client record stays.',
    whatClientCanSee: 'What this client can see',
    alwaysVisible:
      'Always visible: project name, status, dates, address, description, and the progress summary (completion, health, overdue and upcoming tasks, open incident count).',
    defaultsNote:
      'Tasks, schedule dates, activity feed and incidents are on by default; everything else is off until you turn it on.',
    'item.tasks': 'Tasks and their status',
    'item.scheduleDates': 'Schedule dates (task start/end)',
    'item.documents': 'Documents',
    'item.evidence': 'Evidence photos',
    'item.notes': 'Notes',
    'item.activity': 'Activity feed',
    'item.incidents': 'Incidents',
    'item.materials': 'Materials — names and quantities, never cost',
    'item.equipment': 'Equipment — names and hours, never rate',
    'item.priceTotals': 'Price totals (what you charge this client)',
    accessUpdated: 'Client access updated',
    dependencyTasksOn: 'Tasks turned on too — dates live on tasks.',
    dependencyTasksOff: 'Turning off Tasks also turned off its dependent items.',
    managerOnlyNote: 'Only Owner, Admin and Project Manager can change client access.',
    groupWork: 'Work',
    groupFiles: 'Files',
    groupCommunication: 'Communication',
    groupResources: 'Resources',
    groupMoney: 'Money',
  },
  // Sprint 31, story-160/161. Project creation wizard + AI plan generation.
  projectWizard: {
    title: 'New project',
    stepBasics: 'Basics',
    stepSchedule: 'Schedule & location',
    stepTeam: 'Team & client',
    stepBudget: 'Budget',
    stepPlan: 'Plan',
    planQuestion: "How do you want to set up this project's plan?",
    planOptionManualTitle: 'Set up manually',
    planOptionManualBody: 'Start with an empty schedule and add tasks yourself.',
    planOptionTemplateTitle: 'Create from template',
    planOptionTemplateBody: "Import a saved task template's tasks into this project.",
    planOptionAiTitle: 'Generate with AI',
    planOptionAiBody: 'Describe the job or drop files — AI drafts your plan.',
    backToOptions: '← Back to options',
    chooseTemplate: 'Choose template',
    createProject: 'Create project',
    next: 'Next',
    previous: 'Previous',
    discardTitle: 'Discard this project?',
    discardBody: "You'll lose everything you entered on this form.",
    discardConfirm: 'Discard',
    discardCancel: 'Keep editing',
  },
  aiPlan: {
    briefTitle: 'Describe the job',
    briefPlaceholder:
      'E.g. "3-unit townhouse renovation, new electrical panel, 2 bathrooms, finish by end of Q1."',
    attachmentsLabel: 'Attach photos, blueprints, or a bill of materials (optional)',
    dropZoneHint: 'Drop files here or click to browse',
    dropZoneTypes: 'Images, PDF, CSV, XLSX · up to 10 files',
    fileCountOne: '{n} of 10 file',
    fileCountOther: '{n} of 10 files',
    generateSubmit: 'Generate plan →',
    generatingTitle: 'Generating your plan…',
    generatingBody:
      "This usually takes under a minute. You can wait here — the page will update automatically when it's ready.",
    summaryTitle: 'Summary',
    assumptionsTitle: 'Assumptions',
    chatPlaceholder: 'Type a message',
    chatSend: 'Send',
    chatYouLabel: 'You',
    chatAiLabel: 'AI',
    commitCreateProject: 'Create project with this plan →',
    commitImportProject: 'Import into project →',
    commitSaveTemplate: 'Save as template',
    commitCancel: 'Cancel',
    adjustEndDates: 'Adjust project end date to fit this plan',
    failedTitle: 'Something went wrong generating this revision.',
    retry: 'Retry',
    saveTemplateNameLabel: 'Template name',
    saveTemplateSuccess: 'Saved as template',
    leaveTitle: 'Leave without saving?',
    leaveBody: "You'll lose this draft plan.",
    leaveConfirm: 'Leave',
    leaveCancel: 'Keep reviewing',
    progressPreparing: 'Preparing project context',
    progressReading: 'Reading attachments ({i} of {n})',
    progressReadingPending: 'Reading attachments',
    progressReadDone: 'Read {n} attachments',
    progressReadDoneOne: 'Read 1 attachment',
    progressPlanning: 'Planning phases',
    progressPlannedPhases: 'Planned {n} phases',
    progressPlannedPhasesOne: 'Planned 1 phase',
    progressDrafting: 'Drafting phase {k}',
    progressDraftingOf: 'Drafting phase {k} of {n}',
    progressDraftingPending: 'Drafting phases',
    progressDraftedPhases: 'Drafted {n} phases',
    progressDraftedPhasesOne: 'Drafted 1 phase',
    progressValidating: 'Validating and saving',
    progressStarting: 'Starting...',
    progressLeaveHint: 'You can leave this page; your plan keeps generating.',
    progressSlow: 'Still working, large plans can take longer.',
    errUnavailableTitle: 'AI planning is unavailable',
    errUnavailableBody: 'AI planning is temporarily unavailable. Your administrators have been notified.',
    errBusyTitle: 'AI planning is busy',
    errBusyBody: 'AI planning is very busy right now. Please try again in a minute.',
    errGenericTitle: "Couldn't generate the plan",
    errGenericBody: 'Something went wrong while generating this plan. Please try again.',
    changeRemoved: 'Removed: {names}',
    changeRemovedMore: '{names} and {n} more',
    panelTitle: 'In-progress AI plans',
    resumeLink: 'Resume an AI plan ({n})',
    resumeEmpty: 'No AI plans in progress.',
    statusReady: 'Ready to review',
    openDraft: 'Open',
    untitledDraft: 'Untitled AI plan',
    inProgressTitle: 'You have {n} AI plans in progress',
    inProgressTitleOne: 'You have 1 AI plan in progress',
    resumeDraft: 'Resume',
    chatWorking: 'Working on your changes...',
    draftNewProject: 'New project',
    draftTemplate: 'Template',
    draftExistingProject: 'Existing project',
    draftsLoadError: "Couldn't load your AI plans",
    draftGone: 'This AI plan is no longer available',
    draftGoneAction: 'Start over',
    resumeFillDetails: 'Your plan is ready. Fill in the project details first, then create the project.',
    // Discard from the in-progress list: a GENERATING draft is cancelled server-side (the model
    // call is aborted), a READY one is simply removed. Two-step inline confirmation, no modal.
    discardDraft: 'Discard',
    cancelDraft: 'Cancel',
    discardConfirmGenerating: 'Stop generating and discard this plan?',
    discardConfirmReady: 'Discard this plan?',
    discardConfirmYes: 'Yes, discard',
    discardConfirmNo: 'Keep',
    draftDiscarded: 'AI plan discarded',
    draftDiscardFailed: "Couldn't discard the AI plan",
  },
  taskTree: {
    dayOne: '{n} day',
    dayOther: '{n} days',
    materialOne: '{n} material',
    materialOther: '{n} materials',
    equipmentOne: '{n} equipment item',
    equipmentOther: '{n} equipment items',
    addSubtask: '+ Subtask',
    removeTask: 'Remove task',
    catalogChip: 'catalog',
    manualChip: 'manual',
    editName: 'Edit name',
    editDuration: 'Edit duration (days)',
    editStart: 'Edit start day',
    dayN: 'Day {n}',
    deleteTask: 'Delete task',
    deletePhase: 'Delete phase',
    deleteConfirmTask: 'Delete "{name}"?',
    deleteConfirmPhase: 'Delete "{name}" and its {n} tasks?',
    save: 'Save',
    cancel: 'Cancel',
    saving: 'Saving...',
    saveError: "Couldn't save that change. Try again.",
    errNameRequired: 'Name is required.',
    errDuration: 'Duration must be a whole number of at least 1 day.',
    errStart: 'Start day must be a whole number, 0 or more.',
    errNumber: 'Enter a number.',
    noTasks: 'No tasks',
  },
  // Sprint 31, story-161. The Templates page's "Generate with AI" entry point.
  templatesPage: {
    generateWithAi: 'Generate with AI',
  },
  projects: {
    project: 'Project',
    addProject: 'Add New Project',
    name: 'Project Name',
    address: 'Address',
    nameErrorMessage: 'Name must be at least 3 characters long',
    addressErrorMessage: 'The address must be at least 3 characters long',
    startErrorMessage: 'Please enter a valid date in the format MM/DD/YYYY',
    endErrorMessage: 'Please enter a valid date in the format MM/DD/YYYY',
    rangeErrorMessage: 'End date cannot be before start date',
    budgetErrorMessage: 'Please enter a number greater than 0',
    // Sprint 25, story-128 (D8). Shown under the Description field on create/edit — the field is
    // client-facing whenever the project has (or may end up with) a client.
    descriptionClientVisibleNote:
      "This description is also visible to the project's client.",
    // Sprint 25, story-129. Sidebar sectioning for the sub-org's project list.
    sectionYours: 'Your projects',
    sectionDelegated: 'Delegated to you ({n})',
    delegatedBanner:
      'Delegated by {org} · their project "{project}". You run crews, materials, equipment and time here; {org} tracks progress from their side.',
    badgeDelegated: 'Delegated',
    selfMirrorLink: 'Your organization — delegated copy',
    // ProjectStatus → Spanish (house style §5) — the actual render call site for
    // `getProjectStatusLabel`/`ProjectStatusBadge`, mirrors mobile's `projects.status*` keys.
    statusOngoing: 'Active',
    statusCompleted: 'Completed',
    statusAbandoned: 'Abandoned',
    statusDelayed: 'Delayed',
    statusBidding: 'Bidding',
    statusDraft: 'Draft',
    statusBehind: 'Behind',
    allStates: 'All States',
    newProject: 'New Project',
    noProjectsYet: 'No Projects Yet',
    tabProjectFeed: 'Project Feed',
    tabDocuments: 'Documents',
    tabEvidence: 'Evidence',
    // Sprint 43, story-224. CLIENT project-detail tabs (checklist-driven). Retry reuses `common.retry`.
    tabTasks: 'Tasks',
    tabIncidents: 'Incidents',
    clientTasksColTask: 'Task',
    clientTasksColStatus: 'Status',
    clientTasksColType: 'Type',
    clientTasksColStart: 'Start',
    clientTasksColEnd: 'End',
    clientTasksEmpty: 'No tasks to show yet.',
    clientIncidentsEmpty: 'No incidents reported on this project.',
    clientTabLoadError: "We couldn't load this section. Try again.",
    clientAccessLoadError: "We couldn't load your project. Try again.",
    tabVisitors: 'Visitors',
    visitorsNowLabel: 'Now',
    tabInvoices: 'Invoices',
    deleteProjectTitle: 'Delete Project',
    confirmDeleteProject: 'Are you sure you want to delete this project?',
    projectFallbackName: 'Project',
    // Sprint 31, story-156. CreateEditProjectModal — extends this existing flat section directly
    // per house style §6's reuse-by-default rule, sharing terminology with mobile's
    // CreateEditProjectModal wherever the field is the same (see redesign/src/i18n/en.ts's
    // matching keys). `name`/`address`/`descriptionClientVisibleNote` above are reused verbatim.
    editProjectModalTitle: 'Edit Project',
    addProjectModalTitle: 'Add Project',
    updateProjectButton: 'Update Project',
    siteImageDropTitle: 'Drop site image here, or click to select',
    siteImageDropSubtitle: 'PNG, JPG, GIF up to 50MB',
    namePlaceholder: 'Enter project name',
    stateLabel: 'State',
    statePlaceholder: 'Enter project state',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter a project description',
    startDateLabel: 'Start Date',
    startDatePlaceholder: 'Enter project start date',
    endDateLabel: 'End Date',
    endDatePlaceholder: 'Enter project end date',
    addressPlaceholder: 'Enter project address',
    projectManagerLabel: 'Project Manager',
    projectManagerPlaceholder: 'Select a project manager',
    superintendentsLabel: 'Superintendents',
    superintendentsPlaceholder: 'Select superintendents',
    reviewersLabel: 'Reviewers',
    reviewersPlaceholder: 'Select reviewers',
    clientLabel: 'Client',
    clientPlaceholder: 'Select a client',
    budgetLabel: 'Budget',
    budgetPlaceholder: 'Enter project budget',
    totalManHoursLabel: 'Total Man-Hours',
    totalManHoursPlaceholder: 'Enter total man-hours',
    createFromTemplateButton: 'Create from Template',
    selectTemplateModalTitle: 'Select a Template',
    createWithTemplateButton: 'Create with Template',
    pendingInvoiceItemsTitle: 'Pending invoice items',
    completeAnywayButton: 'Complete anyway',
    // Sprint 31, story-156/story-158 overlap (converted while already touching this code, per
    // standing rule #7 "sweep the class" — house style §11.1's xOne/xOther convention replaces
    // the previous hand-rolled `materialCount + ' material(s)'` shape).
    invoicePendingMaterialOne: '{n} material',
    invoicePendingMaterialOther: '{n} materials',
    invoicePendingEquipmentOne: '{n} equipment item',
    invoicePendingEquipmentOther: '{n} equipment items',
    invoicePendingTaskOne: '1 task',
    invoicePendingTaskOther: '{n} tasks',
    // Fixed two-item join (materials/equipment) — never more than two parts, so this does not
    // need the general list-conjunction `joinWithY` helper story-158 introduces.
    invoicePendingJoiner: ' and ',
    invoicePendingDescription:
      'This project has {items} across {taskLabel} not yet invoiced{sample}. If you complete the project now, these will be flagged as pending invoice items. Complete anyway?',
    invoicePendingSampleSuffix: ' (e.g. {names})',
    submitFailedFallback: 'Failed to create project. Please try again.',
    // Guard-invisible (a `.map()`-produced SelectOption array, not a static literal table) —
    // fixed anyway while already in this file, per standing rule #7.
    unknownEmployeeFallback: 'Unknown Employee',
    unknownReviewerFallback: 'Unknown Reviewer',
    // Guard-invisible (Yup `validationSchema` string arguments, not a JSX/toast/prop-list site) —
    // fixed anyway per standing rule #7; these render through `errors.<field>` on this same modal.
    nameRequiredError: 'Project name is required',
    budgetPositiveError: 'Budget must be a positive number',
    totalManHoursPositiveError: 'Total man-hours must be a positive number',
    startDateRequiredError: 'Start date is required',
    endDateRequiredError: 'End date is required',
    stateRequiredError: 'State is required',
  },
  incidents: {
    // Sprint 31, story-158 (house style §13.2). `DetailedIncidentCard`/`IncidentCard` — the
    // `count > 1` (not `!== 1`) zero-handling bug named at this story's seven sites, fixed while
    // converting (both cards are gated on count > 0 today, but the correct comparison is kept
    // regardless of the current gate).
    documentCountOne: '{n} file',
    documentCountOther: '{n} files',
    reportIncident: 'Report Incident',
    modalTitle: 'Report Incident',
    project: 'Project',
    selectProject: 'Select a project...',
    selectProjectFirst: 'Select a project first',
    name: 'Incident Name',
    namePlaceholder: 'Enter incident name',
    time: 'Time of Incident',
    type: 'Incident Type',
    selectType: 'Select type...',
    typeWeather: 'Weather',
    typeAccident: 'Accident',
    typeMaterialsIssue: 'Materials Issue',
    typeEquipmentIssue: 'Equipment Issue',
    typeOther: 'Other',
    otherType: 'Other Type',
    otherTypePlaceholder: 'Enter incident type',
    delay: 'Delay',
    delayUnit: 'Delay Unit',
    selectUnit: 'Select unit...',
    unitHours: 'Hours',
    unitDays: 'Days',
    unitWeeks: 'Weeks',
    description: 'Description',
    descriptionPlaceholder: 'Describe the incident...',
    affectedTasks: 'Affected Tasks (optional)',
    affectedTasksPlaceholder: 'Search and select tasks...',
    attachments: 'Attachments (optional)',
    cancel: 'Cancel',
    submit: 'Report Incident',
    submitting: 'Reporting...',
    projectRequired: 'Project is required',
    nameRequired: 'Incident name is required',
    timeRequired: 'Time of incident is required',
    typeRequired: 'Incident type is required',
    otherTypeRequired: 'Please specify the incident type',
    delayRequired: 'Delay is required',
    delayMustBeNumber: 'Delay must be a number',
    delayMustBePositive: 'Delay must be positive',
    delayUnitRequired: 'Delay unit is required',
    descriptionRequired: 'Description is required',
    success: 'Incident reported successfully',
    error: 'Failed to report incident',
  },
  // Sprint 25, story-134. The reimagined subcontractor page — docs/ux/story-134-design.md.
  subcontractors: {
    since: 'Since {date}',
    projectsCount: '{n} of my projects',
    tasksBreakdown: '{n} tasks ({active} active · {complete} complete · {cancelled} cancelled)',
    agreedPrice: 'Agreed price',
    notSet: 'Not set',
    withoutPrice: '{n} tasks without a price',
    healthOnTrack: 'On track',
    healthBehind: 'Behind',
    healthNotStarted: 'Not started',
    healthComplete: 'All complete',
    healthNone: 'Nothing delegated',
    complete: '{pct}% complete',
    overdue: '{n} overdue',
    avgDaysLate: 'avg {d} d late ({n})',
    earned: 'Earned to date',
    ofAgreed: '{pct}% of agreed',
    atRisk: 'At risk',
    onOverdue: 'on overdue tasks',
    tabOverview: 'Overview',
    tabWork: 'Work',
    tabBids: 'Bids',
    tabActivity: 'Activity',
    needsAttention: 'Needs attention',
    allClear: 'All clear',
    awaitingApproval: 'Awaiting my approval ({n})',
    openIncidents: 'Open incidents on their work ({n})',
    overdueGroup: 'Overdue ({n})',
    progressByProject: 'Progress by project',
    dueThisWeek: '{n} due this week',
    spendVsAgreed: 'Spend vs agreed',
    colAgreed: 'Agreed',
    colEarned: 'Earned',
    colRemaining: 'Remaining',
    colAtRisk: 'At risk',
    earnedNote: 'Earned = agreed price of completed tasks. Not linked to invoices.',
    materialsEquipment: 'Materials & equipment on delegated work',
    rollup: '{m} materials · {e} equipment · client-price side {amount}',
    colTask: 'Task',
    colStatus: 'Status',
    colStart: 'Start',
    colEnd: 'End',
    colLateLeft: 'Late/left',
    colOrigin: 'Origin',
    daysLate: '{d} d late',
    daysLeft: '{d} d left',
    doneOn: 'done {date}',
    originBid: 'Bid · {amount}',
    originDirect: 'Direct',
    cancelledGroup: '{n} cancelled',
    inventoryLine: '{m} materials · {e} equipment',
    costHiddenNote: "Sub's cost basis hidden — names, quantities and client-price side only",
    winRate: 'Win rate {pct}% ({won} of {closed} closed)',
    avgVsCeiling: 'Accepted avg {pct}% of ceiling',
    openBids: '{n} open',
    colSent: 'Sent',
    colProjectTask: 'Project · Task',
    colCeiling: 'My ceiling',
    colTheirBid: 'Their bid',
    colOutcome: 'Outcome',
    outcomeAccepted: 'Accepted',
    outcomeDeclined: 'Declined',
    outcomeCountered: 'Countered',
    outcomeOpen: 'Open',
    outcomeCancelled: 'Cancelled',
    emptyDelegated: 'Nothing delegated yet.',
    emptyDelegatedHint: 'Send {sub} a bid request or delegate a task from a project.',
    emptyBids: 'No bids exchanged with {sub} yet.',
    noPricesYet: 'No agreed prices yet',
    rosterAllClear: 'All clear · {n} active',
    rosterLine: '{overdue} overdue · {approvals} approval(s) · {incidents} incident(s)',
  },
  schedule: {
    // Sprint 38, story-209. Project/Month timeline range switch in the schedule toolbar.
    viewProject: 'Project',
    viewMonth: 'Month',
    viewMonthTooltip: 'Month timeline',
    viewRangeLabel: 'Timeline range',
    // Sprint 31, story-161. Accordion "Generate with AI" entry point, beside Import Template.
    generateWithAi: 'Generate with AI',
    // Sprint 25, story-133. NOAA weather on the schedule calendar.
    weatherForecast: 'Forecast',
    weatherObserved: 'Observed',
    weatherObservedSoFar: 'Observed so far',
    weatherWorstWindow: 'worst between {start} and {end}',
    weatherHigh: 'High',
    weatherLow: 'Low',
    weatherPrecip: 'Precip',
    weatherPrecipChance: '{pct}% precip',
    weatherSource: 'Source: NOAA',
    weatherSourceStation: 'Source: NOAA · station {station}',
    weatherLegend: 'Weather: outline = forecast, solid = observed (worst {start}–{end})',
    weatherNoLocation: 'No weather — add a project location',
    weatherConditionThunderstorm: 'Thunderstorms',
    weatherConditionIce: 'Freezing rain / ice',
    weatherConditionSnow: 'Snow',
    weatherConditionHeavyRain: 'Heavy rain',
    weatherConditionRain: 'Rain',
    weatherConditionDrizzle: 'Drizzle',
    weatherConditionFog: 'Fog',
    weatherConditionWind: 'Windy',
    weatherConditionCloudy: 'Cloudy',
    weatherConditionPartlyCloudy: 'Partly cloudy',
    weatherConditionClear: 'Clear',
    // Sprint 34, story-133 CR. Timeline drag/resize feedback, previously hardcoded.
    invalidDateFormat: 'Invalid date format',
    taskAndSubtasksUpdated: 'Task and subtasks updated successfully',
    parentExtendedSubtaskUpdated: 'Parent task extended and subtask updated successfully',
    updatingTask: 'Updating:',
  },
  // Sprint 28, story-144. Mirrors mobile's `dashboard.*` section name (docs/architecture.md
  // "## Sprint 28" Decision 1 — same concept, landing page after login, on both surfaces).
  dashboard: {
    noAccess: 'You do not have access to this page',
    createProject: 'Create Project',
    noProjectsYet: 'No Projects Yet',
    activeProjects: 'Active Projects',
    recentActivity: 'Recent Activity',
    noRecentActivity: 'No recent activity',
    allProjects: 'All Projects',
    refresh: 'Refresh',
    filterByProject: 'Filter by Project',
    noActiveProjects: 'No active projects',
    noActivitiesToDisplay: 'No activities to display',
    // Sprint 43, story-223. CLIENT home (`/dashboard` for the CLIENT role).
    clientViewBanner: "You're viewing {org}'s projects as a client. This account is view-only.",
    clientViewBannerDismiss: 'Dismiss',
    clientYourProjects: 'Your Projects',
    clientNoProjects: "No projects yet — {org} hasn't added you to a project.",
    clientProjectDates: '{start} - {end}',
    clientProjectStarts: 'Starts {start}',
    clientProjectNoDates: 'Dates to be set',
    clientOpenProject: 'Open project {name}',
    clientLoadError: "We couldn't load your projects. Try again.",
    clientRetry: 'Try again',
    viewGeofence: 'View geofence',
    // Sprint 31, develop run 2 (priority 1/2, TriageFilterBar sweep — the array the guard's
    // blind-spot-4 fix newly caught).
    triageAllLabel: 'All Activity',
    triageIncidentsLabel: 'Incidents',
    triageBidsLabel: 'Bids',
    triageInvoicesLabel: 'Invoices',
  },
  // Sprint 31, develop run 2 (priority 2, Invoices screen sweep). Same key names on both
  // surfaces (`redesign/src/i18n/en.ts`'s mirrored `invoices` section) — the tab list is
  // structurally identical, only `tabPending`'s exact wording differs per surface.
  invoices: {
    tabAll: 'All',
    tabPending: 'Pending Invoices',
    tabDrafts: 'Drafts',
    tabSent: 'Sent',
    tabPaid: 'Paid',
    tabVoided: 'Voided',
    tabErrors: 'Errors',
  },
  // Sprint 28, story-144 (AC2). New, mirrored with mobile's `taskDetail` section name exactly
  // (docs/architecture.md "## Sprint 28" Decision 1). Covers this story's named example — the
  // task status-transition confirmation dialog.
  taskDetail: {
    confirmChangeStatusTo: 'Are you sure you want to change the task status to "{status}"?',
    warningIrreversible: 'This change will be applied immediately and may be irreversible.',
    warningLabel: 'Warning:',
    completeWithIncompleteSubtasksTitle: 'Complete Task with Incomplete Subtasks',
    warningIrreversibleContinue:
      'This change will be applied immediately and is irreversible. Are you sure you want to continue?',
    pendingInvoiceItemsTitle: 'Pending invoice items',
    // Sprint 31, story-158 (house style §13.2/§13.5). `count > 1` (not `!== 1`) is the same
    // zero-handling bug named at the story's seven sites — fixed here too while converting.
    incompleteSubtaskOne: '{n} incomplete subtask',
    incompleteSubtaskOther: '{n} incomplete subtasks',
    completeWithIncompleteSubtasksMessage:
      'This task has {subtasks}. Marking this task as complete will not affect the status of these subtasks.',
    materialUnbilledOne: '{n} unbilled material',
    materialUnbilledOther: '{n} unbilled materials',
    equipmentUnbilledOne: '{n} unbilled equipment',
    equipmentUnbilledOther: '{n} unbilled equipment',
    taskInvoicePendingMessage:
      'This task still has {material} and {equipment}.\n\nWe recommend creating the invoice before marking the task as complete so nothing gets missed.',
    pendingSamplesPrefix: '\n\nPending: ',
    completeAnywayButton: 'Complete anyway',
    reasonForRejection: 'Reason for Rejection (Optional)',
    enterRejectionReason: 'Enter reason for rejecting this task...',
    confirmChange: 'Confirm Change',
    updating: 'Updating...',
    confirmStatusChangeTitle: 'Confirm Status Change',
    delegatedCannotChangeStatus:
      'This task was delegated to another organization. You cannot change the status until they submit their completed work back to you.',
    delegationBanner: 'Delegated Task:',
    delegationBannerText: 'This task was delegated from {org}',
    // Sprint 28, develop run 3 (story-144 review Critical #1 fix). House style §5's canonical
    // status vocabulary — exact key names mirror mobile's `taskDetail.status*` (docs/architecture.md
    // "## Sprint 28" Decision 1's shared-name rule for `taskDetail`). Consumed via
    // `getTranslatedTaskStatusLabel`/`getTranslatedTaskStatusOptions` (`@utils/options`), never
    // read directly off `TaskStatusOptions.name`, which stays English-only for story-071's
    // label-stability test.
    statusActive: 'Active',
    statusInactive: 'Inactive',
    statusComplete: 'Complete',
    statusInternalApproval: 'Pending Internal Approval',
    statusClientApproval: 'Pending Client Approval',
    statusRejected: 'Rejected',
    statusCanceled: 'Canceled',
    statusDelegationCanceled: 'Delegation Canceled',
    // Sprint 28 change request (global sweep, defect fix). `statusUnknown` is new (mobile
    // already had it); the six `display*` keys are `TaskDisplayValues`' derived-only members
    // (not plain `TaskStatus`) — see `@utils/taskDisplay.ts`'s `translateTaskDisplayValue`.
    statusUnknown: 'Unknown',
    displayUpcoming: 'Upcoming',
    displayBehindSchedule: 'Behind Schedule',
    displayAssignedToSubcontractor: 'Assigned to Subcontractor',
    displayAssignedToCrew: 'Assigned to Crew',
    displayInNegotiations: 'In Negotiations',
    displayUnassigned: 'Unassigned',
    // Sprint 28, story-144 (residual gap). CreateEditTaskModal's BudgetTab subtree.
    budget: {
      subTabReceived: 'Received Bid',
      subTabDelegated: 'Sub-delegated Bid',
      tabActive: 'Active Budget',
      tabPast: 'Past Budgets',
      delegationInfoTitle: 'Delegation Information',
      delegatedTo: 'Delegated To',
      currentOrganization: 'Current Organization',
      originalAcceptedOrg: 'Original Accepted Organization',
      notAvailable: 'N/A',
      noBidActivityTitle: 'No Bid Activity',
      delegationBidDetailsTitle: 'Delegation Bid Details',
      subDelegationBidDetailsTitle: 'Sub-delegation Bid Details',
      noBidRequestFoundTitle: 'No Bid Request Found',
      delegatedNoBidRequestMessage:
        'This task has been delegated to another organization, but no bid request data was found.',
      taskDelegatedTo: 'Task delegated to:',
      unknownOrganization: 'Unknown Organization',
      noBudgetActivityTitle: 'No Budget Activity',
      noBudgetActivityMessage: "This task doesn't have any bid requests associated with it yet.",
      headerDelegatedBid: 'Delegated Bid',
      headerReceivedBidRequest: 'Received Bid Request',
      headerSubDelegatedBid: 'Sub-delegated Bid',
      headerBidRequest: 'Bid Request',
      statusCompletedCancelled: 'COMPLETED (CANCELLED)',
      badgeReceived: 'RECEIVED',
      badgeSent: 'SENT',
      cancelledBadge: 'CANCELLED',
      pastDelegationBid: 'Past Delegation Bid',
      pastDelegationBids: 'Past Delegation Bids',
      cancelledSingleMessage: 'This bid request was for a delegation that has been cancelled.',
      cancelledMultipleMessage:
        'These {n} bid requests were for delegations that have been cancelled.',
      cancelledDelegationTo: 'Cancelled Delegation to:',
      unknown: 'Unknown',
      amount: 'Amount:',
      start: 'Start:',
      end: 'End:',
      accepted: 'Accepted:',
      cancelled: 'Cancelled:',
      delegatedTaskId: 'Delegated Task ID:',
      viewDetails: 'View Details',
      notSpecified: 'Not specified',
      originalProject: 'Original Project',
      project: 'Project',
      originalTask: 'Original Task',
      task: 'Task',
      currentDelegatedTask: 'Current Delegated Task',
      delegatedProject: 'Delegated Project',
      delegationRecipient: 'Delegation Recipient',
      budgetRecipients: 'Budget Recipients',
      subDelegationRecipient: 'Sub-delegation Recipient',
      budgetOriginator: 'Budget Originator',
      originatorOrganization: 'Originator Organization',
      assignedOrganization: 'Assigned Organization',
      status: 'Status',
      // Sprint 28 change request (global sweep, defect fix). `BudgetRequestRecipientStatus`
      // (`@models/budget.model`) rendered raw at 4 sites in this subtree (`BudgetRequestCard`,
      // `TaskProjectInfo` x3, including the `yourStatus` template).
      recipientStatusSent: 'Sent',
      recipientStatusViewed: 'Viewed',
      recipientStatusResponded: 'Responded',
      recipientStatusAccepted: 'Accepted',
      recipientStatusRejected: 'Rejected',
      delegationCreated: 'Delegation Created',
      subDelegationCreated: 'Sub-delegation Created',
      taskCreatedFromAcceptedBid: 'Task Created from Accepted Bid',
      yourStatus: 'Your Status: {status}',
      bidAcceptedBy: 'Bid Accepted by {org}',
      bidRequestPending: 'Bid Request Pending',
      originalBidDetailsTitle: 'Original Bid Details',
      bidDetailsTitle: 'Bid Details',
      amountLabel: 'Amount',
      startDateLabel: 'Start Date',
      endDateLabel: 'End Date',
      delegationDate: 'Delegation Date',
      subDelegationDate: 'Sub-delegation Date',
      acceptedDate: 'Accepted Date',
      description: 'Description',
      attachedDocuments: 'Attached Documents',
      delegationLabel: 'Delegation',
      subDelegationLabel: 'Sub-delegation',
      budgetRequestLabel: 'Budget Request',
      loadingBudgetInfo: 'Loading budget information...',
      noBudgetRequestsYet: "This task doesn't have any budget requests associated with it yet.",
      delegationBudgetNumber: 'Delegation Budget #{n}',
      subDelegationBudgetNumber: 'Sub-delegation Budget #{n}',
      originalBudgetNumber: 'Original Budget #{n}',
      budgetNumber: 'Budget #{n}',
      viewFullHistory: 'View Full History',
    },
    // Sprint 28, story-144 (residual gap). CreateEditTaskModal's GeneralTab subtree.
    general: {
      statusLabel: 'Status',
      selectStatus: 'Select status',
      statusChangesAppliedImmediately: 'Status changes are applied immediately',
      statusLocked: 'Status Locked:',
      delegatedTaskLabel: 'Delegated Task:',
      statusOptionsLimitedMessage:
        "Status options are limited based on your organization's role in the delegation chain.",
      addSubtaskTitle: 'Add Subtask',
      selectTasksToAddLabel: 'Select Tasks to Add as Subtasks',
      chooseTasksPlaceholder: 'Choose tasks...',
      cancel: 'Cancel',
      adding: 'Adding...',
      addSubtaskButton: 'Add Subtask',
      addSubtasksButton: 'Add Subtasks',
      subtasksTitle: 'Subtasks',
      createSubtask: 'Create Subtask',
      importTemplate: 'Import Template',
      infoLabel: 'Info:',
      delegatedNoSubtasksMessage: "This task can't have subtasks because it's delegated.",
      pendingBudgetNoSubtasksMessage:
        "This task can't have subtasks while a bid request is pending approval.",
      colName: 'Name',
      colStatus: 'Status',
      colStartTime: 'Start Time',
      colEndTime: 'End Time',
      colTaskType: 'Task Type',
      colActions: 'Actions',
      willBeAdded: 'Will be added',
      pendingAdd: 'Pending Add',
      pendingRemove: 'Pending Remove',
      remove: 'Remove',
      undoRemove: 'Undo Remove',
      noSubtasksAssigned: 'No subtasks assigned yet.',
      clickAddSubtasksHint: 'Click "Add Subtasks" to select existing tasks as subtasks.',
      noAvailableTasksToAdd: 'No available tasks to add as subtasks.',
    },
    // Sprint 28, story-144 (residual gap). CancelWarningModal, DocumentsTab.
    cancelWarningBudgetTitle: 'Cancel Bid Request',
    cancelWarningBudgetMessage:
      'This will cancel the active bid request process. All bid proposals will be rejected and recipient organizations will be notified.',
    cancelWarningBudgetConsequence1: 'Active bid request will be cancelled',
    cancelWarningBudgetConsequence2: 'All bid proposals will be rejected',
    cancelWarningBudgetConsequence3: 'Recipient organizations will be notified',
    cancelWarningBudgetConsequence4:
      'You can then assign the task to your crew or create a new bid request',
    cancelWarningDelegationTitle: 'Cancel Task Delegation',
    cancelWarningDelegationMessage:
      'This will cancel the task delegation to {org}. The delegated organization will lose access to this task.',
    cancelWarningDelegationDefaultOrg: 'the subcontractor',
    cancelWarningDelegationConsequence1: 'Current delegation will be cancelled',
    cancelWarningDelegationConsequence2:
      'Any work progress or costs recorded by the subcontractor will be preserved',
    cancelWarningDelegationConsequence3:
      'You can then assign the task to your crew or delegate to a different organization',
    cancelWarningCannotBeUndone: 'This action cannot be undone',
    cancelWarningWhatWillHappen: 'What will happen:',
    cancelWarningConfirmPrefix: 'Are you sure you want to proceed?',
    cancelWarningWillImmediately: 'This action will immediately',
    cancelWarningConfirmSuffixBudget: ' cancel the bid request',
    cancelWarningConfirmSuffixDelegation: ' cancel the delegation',
    cancelWarningConfirmSuffix: 'and cannot be reversed.',
    keepCurrentAssignment: 'Keep Current Assignment',
    cancelBidRequestButton: 'Cancel Bid Request',
    cancelDelegationButton: 'Cancel Delegation',
    existingDocuments: 'Existing Documents',
    addNewDocuments: 'Add New Documents',
    documentsLabel: 'Documents',
    dropDocumentsHere: 'Drop documents here, or click to select',
    documentsSubtitle: 'PDF, TXT, CSV, images up to 50MB each',
    // Sprint 28, story-144 (residual gap). SelectedCrewMembers, AssignmentTab.
    memberSingular: 'member',
    memberPlural: 'members',
    noMembersAssigned: 'No members assigned',
    unknownUser: 'Unknown',
    // Sprint 28, story-144 (residual gap). InventoryItem and inventory/materials/equipment tabs.
    inventory: {
      qty: 'Qty:',
      cost: 'Cost:',
      total: 'Total:',
      from: 'From:',
      returnToWarehouse: 'Return to warehouse',
    },
    // Sprint 28, story-144 (residual gap). DateConflictModal.
    dateConflict: {
      title: 'Date Conflict Warning',
      description:
        'Some subtasks have dates that conflict with the main task dates. The main task dates will be automatically adjusted to accommodate all subtasks.',
      mainTaskDateChanges: 'Main Task Date Changes:',
      currentStart: 'Current Start:',
      currentEnd: 'Current End:',
      conflictingSubtasks: 'Conflicting Subtasks:',
      subtaskStartsConflict:
        'Subtask starts on {date}, which is before the main task start date ({mainDate})',
      subtaskEndsConflict:
        'Subtask ends on {date}, which is after the main task end date ({mainDate})',
      note: 'Note:',
      noteMessage:
        'By proceeding, the main task dates will be adjusted to ensure all subtasks fall within the main task timeline. This action cannot be undone.',
      cancel: 'Cancel',
      saving: 'Saving...',
      continueAndAdjustDates: 'Continue & Adjust Dates',
    },
    // Sprint 28, story-144 (residual gap). EquipmentSubTab.
    equipment: {
      title: 'Task Equipment',
      itemSingular: 'item',
      itemPlural: 'items',
      inUseSuffix: '{n} in use',
      reservedSuffix: '{n} reserved',
      plannedSuffix: '{n} planned',
      returnedSuffix: '{n} returned',
      manualSuffix: '{n} manual',
      addManually: 'Add Manually',
      reserve: 'Reserve',
      checkoutFromAssets: 'Checkout from Assets',
      infoBanner:
        'Use "Checkout from Assets" to use tracked equipment, "Reserve" to hold for future use, or "Add Manually" for untracked equipment. Returned equipment stays visible in the list.',
      loadingEquipment: 'Loading equipment...',
      colSource: 'Source',
      colEquipment: 'Equipment',
      colStatus: 'Status',
      colEstHours: 'Est. Hours',
      colCostHr: 'Cost/Hr',
      colPriceHr: 'Price/Hr',
      colTotalCost: 'Total Cost',
      colActions: 'Actions',
      badgeAsset: 'Asset',
      // Sprint 31, story-149 (Instance 2) judgment call: NOT the same concept as
      // `enumLabels.taskEquipmentStatusPlanned` below despite the identical English word — this
      // badge labels the equipment's *source* (manually-added vs. pulled from warehouse assets),
      // not its `TaskEquipmentStatus`. Left as its own key.
      badgePlanned: 'Planned',
      returnEquipmentAction: 'Return equipment',
      checkoutReservedAction: 'Checkout reserved equipment',
      removeEquipmentAction: 'Remove equipment',
      editEquipmentAction: 'Edit equipment',
      totals: 'Totals',
      noEquipmentAdded:
        'No equipment added. Use "Checkout from Assets" to assign tracked equipment, "Reserve" to hold it, or "Add Manually" for untracked equipment.',
      legendInUse: '= Currently checked out',
      legendReserved: '= Reserved for this task',
      legendReturned: '= Returned to warehouse',
      legendPlanned: '= Planned (no asset assigned)',
      legendManual: '= Added manually',
      units: 'units',
      hrs: 'hrs',
    },
    // Sprint 28, story-144 (residual gap). MaterialsSubTab.
    materials: {
      title: 'Task Materials',
      itemsCostSummary: '{n} items · Cost: {cost}',
      clientSuffix: ' · Client: {price}',
      calculator: 'Calculator',
      addManually: 'Add Manually',
      addFromWarehouse: 'Add from Warehouse',
      infoBannerReserved: 'Reserved',
      infoBannerPlanned: 'Planned',
      infoBannerPrefix: 'Materials can be',
      infoBannerMiddle: '(held in warehouse) or',
      infoBannerSuffix:
        '(no stock impact). Reserved materials must be consumed before stock is decremented.',
      pendingReservationSingular: 'material pending reservation. Reserve them when stock becomes available.',
      pendingReservationPlural: 'materials pending reservation. Reserve them when stock becomes available.',
      loadingMaterials: 'Loading materials...',
      colSource: 'Source',
      colStatus: 'Status',
      colMaterial: 'Material',
      colQuantity: 'Quantity',
      colUnitCost: 'Unit Cost',
      colTotalCost: 'Total Cost',
      colChargeClient: 'Charge Client',
      colClientPrice: 'Client Price',
      colActions: 'Actions',
      skuLabel: 'SKU: {sku}',
      reserveFromWarehouse: 'Reserve from warehouse',
      insufficientStock: 'Insufficient stock (available: {n})',
      markAsConsumed: 'Mark as consumed',
      returnToWarehouseAction: 'Return to warehouse',
      removeMaterialAction: 'Remove material',
      editMaterialAction: 'Edit material',
      totals: 'Totals',
      noMaterialsAdded:
        'No materials added. Use "Add from Warehouse", "Add Manually", or the Calculator to get started.',
      legendStockUpdated: '= Stock automatically updated',
      legendManual: '= Added manually',
      // Sprint 34, story-176. Summary-line loading/error states (docs/ux/story-176-design.md).
      summaryLoadError: "Couldn't load totals",
      summaryRetry: 'Retry',
    },
    // Sprint 28, story-144 (residual gap). InventoryTab (materials/equipment sub-tab shell + modals).
    inventoryTab: {
      saveTaskFirstTitle: 'Save the task first',
      saveTaskFirstMessage:
        'To manage materials and equipment from the warehouse, please save the task first using the Create button.',
      materialsTabLabel: 'Materials',
      equipmentTabLabel: 'Equipment',
      removeMaterialTitle: 'Remove Material',
      removeMaterialConfirm: 'Are you sure you want to remove "{name}"?',
      reservedMaterialReleaseNote:
        'The reservation will be released and stock will become available again.',
      plannedMaterialNoStockNote: 'This is a planned material — no stock changes will occur.',
      warehouseStockReturnedNote: 'Stock will be returned to the warehouse.',
      remove: 'Remove',
      cancel: 'Cancel',
      removeEquipmentTitle: 'Remove Equipment',
      removeEquipmentConfirm: 'Are you sure you want to remove "{name}"?',
      reservedEquipmentCancelNote:
        'The reservation will be cancelled and the asset will become available again.',
      plannedEquipmentNoAssetNote: 'This is a planned equipment — no asset changes will occur.',
      checkoutEquipmentTitle: 'Checkout Equipment',
      checkoutEquipmentConfirm:
        'Are you sure you want to checkout "{name}"? The reservation will be completed and the equipment status will change to In Use.',
      checkout: 'Checkout',
    },
    // Sprint 28, story-144 (residual gap). DependenciesTab.
    dependencies: {
      otherTasksGroup: 'Other tasks',
      wouldCreateCycle: '(would create a cycle)',
      alreadyImplied: '(already implied)',
      mainBadge: 'Main',
      removeAriaLabelPrefix: 'Remove',
      precedingTaskLabel: 'Preceding Task',
      precedingEventLabel: 'Preceding Event',
      searchPrecedingTasksPlaceholder: 'Search and select preceding tasks...',
      selectPrecedingEventsPlaceholder: 'Select preceding events...',
      conflictTitle: 'Precedent task is after current task',
      conflictThisEnds: 'This precedent ends',
      conflictTheseEnd: 'These precedents end',
      conflictAfterThisTaskStartsOn: 'after this task starts on {date}',
      conflictAfterThisTaskStarts: 'after this task starts',
      conflictSaveAnywayNote: 'You can still save — the dependency will just be out of order.',
      conflictOccurs: 'occurs',
      conflictEnds: 'ends',
    },
    // Sprint 28, story-144 (residual gap). ActivityTab.
    activityTab: {
      addActivity: 'Add Activity',
      selectedFiles: 'Selected files ({n}):',
      removeFile: 'Remove file',
      noteTitlePlaceholder: 'Note title...',
      descriptionPlaceholder: 'Add a description or comment...',
      attachFiles: 'Attach Files',
      addNote: 'Add Note',
      noActivitiesYet: 'No activities yet',
      defaultNoteName: 'Note',
    },
  },
  // Sprint 28, story-144 (residual gap). CreateEditEquipmentModal (manual equipment form).
  equipmentModal: {
    nameMinLength: 'Name must be at least 3 characters',
    nameRequired: 'Name is required',
    supplierOwnerRequired: 'Supplier/Owner is required',
    supplyDeliveryDateRequired: 'Supply/Delivery Date is required',
    hoursUsedPositive: 'Hours used must be positive',
    hoursUsedRequired: 'Hours used is required',
    amountPositive: 'Amount must be positive',
    amountRequired: 'Amount is required',
    costPerHourPositive: 'Cost per hour must be positive',
    costPerHourRequired: 'Cost per hour is required',
    pricePerHourPositiveWhenCharging: 'Price per hour must be positive',
    pricePerHourRequiredWhenCharging: 'Price per hour is required when charging to client',
    pricePerHourPositive: 'Price per hour must be positive',
    saveChanges: 'Save Changes',
    addEquipment: 'Add Equipment',
    editEquipment: 'Edit Equipment',
    nameLabel: 'Name',
    equipmentNamePlaceholder: 'Equipment Name',
    supplierOwnerLabel: 'Supplier/ Owner',
    equipmentSupplierPlaceholder: 'Equipment Supplier/Owner',
    supplyDeliveryDateLabel: 'Supply/Delivery Date',
    hoursUsedLabel: 'Hours Used (estimated)',
    amountLabel: 'Amount (units)',
    costPerHourLabel: 'Cost per Hour',
    chargeToClient: 'Charge to Client',
    pricePerHourLabel: 'Price per Hour',
    rawProfit: 'Raw profit ({amount})',
  },
  // Sprint 28, story-144 (residual gap). CreateEditMaterialModal (manual material form).
  materialModal: {
    nameMinLength: 'Name must be at least 3 characters',
    nameRequired: 'Name is required',
    supplierMinLength: 'Supplier must be at least 3 characters',
    supplierRequired: 'Supplier is required',
    supplyDeliveryDateRequired: 'Supply/Delivery Date is required',
    amountPositive: 'Amount must be positive',
    amountRequired: 'Amount is required',
    costPerUnitPositive: 'Cost per unit must be positive',
    costPerUnitRequired: 'Cost per unit is required',
    pricePerUnitPositiveWhenCharging: 'Price per unit must be positive',
    pricePerUnitRequiredWhenCharging: 'Price per unit is required when charging to client',
    pricePerUnitPositive: 'Price per unit must be positive',
    unitRequired: 'Unit is required',
    systemRequired: 'System is required',
    saveChanges: 'Save Changes',
    addMaterial: 'Add Material',
    editMaterial: 'Edit Material',
    materialNameLabel: 'Material Name',
    materialNamePlaceholder: 'Material Name',
    supplierLabel: 'Supplier',
    materialSupplierPlaceholder: 'Material Supplier',
    supplyDeliveryDateLabel: 'Supply/Delivery Date',
    systemLabel: 'System',
    metricImperialPlaceholder: 'Metric/Imperial',
    unitLabel: 'Unit',
    amountLabel: 'Amount',
    costPerUnitLabel: 'Cost per Unit',
    chargeToClient: 'Charge to Client',
    pricePerUnitLabel: 'Price per Unit',
    rawProfit: 'Raw profit ({amount})',
  },
  // Sprint 28, story-144 (residual gap). CreateEditEventModal.
  eventModal: {
    nameMinLength: 'Name must be at least 3 characters',
    nameRequired: 'Name is required',
    eventTypeRequired: 'Event type is required',
    eventTimeRequired: 'Event time is required',
    otherEventTypeMinLength: 'Other event type must be at least 3 characters',
    otherEventTypeRequired: 'Other event type is required',
    incidentTypeRequired: 'Incident type is required',
    addedIncidentTypeMinLength: 'Added incident type must be at least 3 characters',
    addedIncidentTypeRequired: 'Added incident type is required',
    inspectionTypeRequired: 'Inspection type is required',
    permitMinLength: 'Permit must be at least 3 characters',
    permitRequired: 'Permit is required',
    delayPositive: 'Delay must be positive',
    delayRequired: 'Delay is required',
    delayTypeRequired: 'Delay type is required',
    notesMinLength: 'Notes must be at least 3 characters',
    notesRequired: 'Notes is required',
    atLeastOnePrecedingTask: 'At least one preceding task is required',
    eventUpdatedSuccess: 'Event updated successfully',
    eventCreatedSuccess: 'Event created successfully',
    eventUpdateFailed: 'Failed to update event',
    eventCreateFailed: 'Failed to create event',
    saveChanges: 'Save Changes',
    createEvent: 'Create Event',
    editEvent: 'Edit Event',
    nameLabel: 'Name',
    enterEventNamePlaceholder: 'Enter event name',
    eventTypeLabel: 'Event Type',
    selectEventTypePlaceholder: 'Select event type',
    otherEventTypeLabel: 'Other Event Type',
    enterOtherEventTypePlaceholder: 'Enter other event type',
    eventTimeLabel: 'Event Time',
    selectDatePlaceholder: 'Select date',
    incidentTypeLabel: 'Incident Type',
    selectIncidentTypePlaceholder: 'Select incident type',
    addIncidentTypeLabel: 'Add Incident Type',
    enterIncidentTypePlaceholder: 'Enter incident type',
    inspectionTypeLabel: 'Inspection Type',
    selectInspectionTypePlaceholder: 'Select inspection type',
    permitLabel: 'Permit #',
    enterPermitNumberPlaceholder: 'Enter permit number',
    delayLabel: 'Delay',
    delayTypeLabel: 'Delay Type',
    selectTimeTypePlaceholder: 'Select time type',
    // Sprint 28, develop run 3 (story-144 review Critical #1 fix). `TimeOptions` (@utils/options)
    // stays English-only (same non-component-module rule as `TaskStatusOptions`); this dropdown's
    // option labels are translated here instead.
    delayUnitHours: 'hours',
    delayUnitDays: 'days',
    delayUnitWeeks: 'weeks',
    notesLabel: 'Notes',
    enterNotesPlaceholder: 'Enter notes',
    precedingTasksLabel: 'Preceding Tasks *',
    selectPrecedingTasksPlaceholder: 'Select preceding tasks',
  },
  // Sprint 29, story-148. Status-badge atom family + role map — house pattern per
  // `web/src/app/utils/taskDisplay.ts` (Addendum 5): every map below is exhaustive over its
  // backend enum (`docs/architecture.md` Sprint 29 Addendum 4), and every consumer falls back to
  // `common.unknown` for an unrecognized value, never `.replace()`/raw text. Mirrors mobile's
  // `enumLabels` section (Decision 1 shared-name rule) except where noted (e.g. `punchAction` is
  // mobile-only — punch clock is mobile-only by design).
  enumLabels: {
    equipmentStatusAvailable: 'Available',
    equipmentStatusInUse: 'In Use',
    equipmentStatusMaintenance: 'Maintenance',
    equipmentStatusReserved: 'Reserved',
    equipmentStatusRetired: 'Retired',
    invoiceStatusDraft: 'Draft',
    invoiceStatusSending: 'Sending',
    invoiceStatusSent: 'Sent',
    invoiceStatusPaid: 'Paid',
    invoiceStatusVoided: 'Voided',
    invoiceStatusSendFailed: 'Send Failed',
    transactionTypeReceive: 'Received',
    transactionTypeConsume: 'Consumed',
    transactionTypeAdjust: 'Adjusted',
    transactionTypeReserve: 'Reserved',
    transactionTypeReleaseReserve: 'Released',
    transactionTypeReturn: 'Returned',
    transactionTypeRecovery: 'Recovered',
    transactionTypeTransfer: 'Transferred',
    transactionTypeUseAsEquipment: 'Equipment',
    taskMaterialStatusPlanned: 'Planned',
    taskMaterialStatusReserved: 'Reserved',
    taskMaterialStatusConsumed: 'Consumed',
    taskMaterialStatusReturned: 'Returned',
    // Sprint 31, story-149 (Instance 2). Migrated from `taskDetail.equipment.status*`, a
    // section-local duplicate of exactly the pattern `enumLabels` exists to centralize — mobile
    // already had these under `enumLabels.taskEquipmentStatus*` (story-148/152's convention);
    // web now matches. Values unchanged.
    taskEquipmentStatusPlanned: 'Planned',
    taskEquipmentStatusReserved: 'Reserved',
    taskEquipmentStatusInUse: 'In Use',
    taskEquipmentStatusReturned: 'Returned',
    shapeTypeCircle: 'Circle',
    shapeTypePolygon: 'Polygon',
    roleSuperAdmin: 'Super Admin',
    roleOwner: 'Owner',
    roleAdmin: 'Admin',
    roleProjectManager: 'Project Manager',
    roleSuperintendent: 'Superintendent',
    roleCrewLead: 'Crew Lead',
    roleEmployee: 'Employee',
    roleReviewer: 'Reviewer',
    roleClient: 'Client',
    // Sprint 30, story-152. AdjustmentReason/TransactionStatus — canonical Spanish already
    // ratified in docs/ux/i18n-house-style.md §5b (sprint 29, story-145 revision), wired to
    // code for the first time here.
    adjustmentReasonCountCorrection: 'Count Correction',
    adjustmentReasonDamaged: 'Damaged',
    adjustmentReasonLost: 'Lost',
    adjustmentReasonStolen: 'Stolen',
    adjustmentReasonBroken: 'Broken',
    adjustmentReasonExpired: 'Expired',
    adjustmentReasonFound: 'Found',
    adjustmentReasonTransfer: 'Transfer',
    adjustmentReasonOther: 'Other',
    transactionStatusPending: 'Pending',
    transactionStatusCompleted: 'Completed',
    transactionStatusCancelled: 'Cancelled',
    stockStatusInStock: 'In Stock',
    stockStatusLowStock: 'Low Stock',
    stockStatusOutOfStock: 'Out of Stock',
    equipmentConditionGood: 'Good',
    equipmentConditionFair: 'Fair',
    equipmentConditionNeedsRepair: 'Needs Repair',
    transactionKindPurchase: 'Purchase',
    transactionKindDraw: 'Draw',
    transactionKindAdjustment: 'Adjustment',
    transactionKindTransfer: 'Transfer',
    transactionKindReturn: 'Return',
    transactionKindReserve: 'Reserve',
    transactionKindRelease: 'Release',
    transactionKindRecovery: 'Recovery',
    // Sprint 31, story-157. Billing-domain `TransactionStatus`/`TransactionType`
    // (`@models/subscription`) — distinctly named from the warehouse `transactionStatus*`/
    // `transactionType*` keys above (a different enum, same English words for some values).
    billingTransactionStatusSuccess: 'Success',
    billingTransactionStatusFailed: 'Failed',
    billingTransactionStatusPending: 'Pending',
    billingTransactionStatusRefunded: 'Refunded',
    billingTransactionTypeCharge: 'Charge',
    billingTransactionTypeRefund: 'Refund',
    billingTransactionTypeRetry: 'Retry',
    subscriptionStatusTrial: 'Trial Period',
    subscriptionStatusTrialExpired: 'Trial Ended — Read Only',
    subscriptionStatusActive: 'Active',
    subscriptionStatusPastDue: 'Past Due',
    subscriptionStatusCanceled: 'Canceled',
    subscriptionStatusPaused: 'Paused',
    paymentMethodTypeCreditCard: 'Credit Card',
    paymentMethodTypeAch: 'Bank Account (ACH)',
    paymentMethodTypeDigitalWallet: 'Digital Wallet',
    // Sprint 31, story-158 (house style §13.2). `BudgetDocumentsModal`'s `FileKind` — the
    // `count > 1` (not `!== 1`) zero-handling bug named at this story's seven sites.
    fileKindImageOne: 'Image',
    fileKindImageOther: 'Images',
    fileKindPdfOne: 'PDF',
    fileKindPdfOther: 'PDFs',
    fileKindSheetOne: 'Spreadsheet',
    fileKindSheetOther: 'Spreadsheets',
    fileKindDocOne: 'Document',
    fileKindDocOther: 'Documents',
    fileKindArchiveOne: 'Archive',
    fileKindArchiveOther: 'Archives',
    fileKindOtherOne: 'File',
    fileKindOtherOther: 'Files',
  },
  // Sprint 28, story-144 (residual gap). PaymentMethodSelector/validationSchema.ts — a non-component
  // .ts file per Decision 2, so the translated strings are built via a factory function called from
  // the consuming component(s), never a hook call inside this file itself.
  paymentMethod: {
    selectPaymentMethodRequired: 'Please select a payment method',
    firstNameRequired: 'First name is required',
    lastNameRequired: 'Last name is required',
    invalidEmail: 'Invalid email address',
    emailRequired: 'Email is required',
    addressRequired: 'Address is required',
    cityRequired: 'City is required',
    stateFormat: 'State must be 2 letters (e.g., CA)',
    stateRequired: 'State is required',
    zipRequired: 'ZIP code is required',
    phoneFormat: 'Phone number can only contain digits, spaces, dashes, parentheses, and plus sign',
    phoneMinLength: 'Phone number must be at least 10 digits',
    phoneRequiredAch: 'Phone number is required for ACH payments',
    cardNumberRequired: 'Card number is required',
    invalidCardNumber: 'Invalid card number',
    expirationRequired: 'Expiration date is required',
    expirationFormat: 'Format must be MM/YY',
    cardExpired: 'Card has expired',
    cvvRequired: 'CVV is required',
    cvvFormat: 'CVV must be 3 or 4 digits',
    accountHolderNameRequired: 'Account holder name is required',
    routingNumberFormat: 'Routing number must be 9 digits',
    routingNumberRequired: 'Routing number is required',
    accountNumberRequired: 'Account number is required',
    accountTypeRequired: 'Account type is required',
    accountHolderTypeRequired: 'Account holder type is required',
  },
  // Sprint 31, story-157. New shared top-level section, same name on both surfaces
  // (redesign/src/i18n/en.ts), sub-namespaced per the story's own shape:
  // `ownerBilling/*` (web) and `PaymentAccountScreen`/`AddSeatsModal`/
  // `ReactivateSubscriptionModal` (mobile). Enum display values live in `enumLabels` above per
  // the story-148/152 convention, not duplicated here.
  billing: {
    // Shared across the family, not one modal's own copy.
    cannotUndoWarning: 'This action cannot be undone',
    seats: {
      addSeatsButton: 'Add Seats',
      yourSubscriptionTitle: 'Your Subscription',
      manageSubtitle: 'Manage your plan and purchased seats',
      basePlanBadge: 'Base Plan',
      standardPlanFallback: 'Standard Plan',
      priceLabel: 'Price:',
      seatsLabelColon: 'Seats:',
      sinceLabel: 'Since:',
      perYearSuffix: 'yr',
      perMonthSuffix: 'mo',
      addonBadge: 'Addon',
      removeAddonTitle: 'Remove addon',
      noAdditionalSeatsMessage: 'No additional seats purchased yet.',
      clickAddSeatsHint: 'Click "Add Seats" to purchase more.',
      totalMonthlyCostLabel: 'Total Monthly Cost',
      totalSeatsLabel: 'Total Seats',
      fromBasePlanSuffix: '{n} from base plan',
      fromAddonsOne: '{seats} from {count} addon',
      fromAddonsOther: '{seats} from {count} addons',
      removeAddonModalTitle: 'Remove Addon',
      removeButton: 'Remove',
      noSubscriptionFound: 'No subscription found',
      cannotRemoveTitle: 'Cannot remove this addon',
      cannotRemoveBody1Prefix: 'You currently have',
      activeUserOne: '{n} active user',
      activeUserOther: '{n} active users',
      cannotRemoveBody1Suffix:
        'using your seats. Removing this addon would leave you with insufficient seats.',
      cannotRemoveBody2Prefix: 'To remove this addon, you need to deactivate at least',
      userOne: '{n} user',
      userOther: '{n} users',
      cannotRemoveBody2Suffix: 'first from the',
      usersPageLink: 'Users page',
      confirmRemovePrefix: 'Are you sure you want to remove',
      removeSeatWarningOne: 'This will remove {n} seat from your subscription.',
      removeSeatWarningOther: 'This will remove {n} seats from your subscription.',
      removeAddonFinalNote:
        'The addon subscription will be canceled. No refund will be issued for the remaining period.',
      additionalSeatOne: '{n} additional seat',
      additionalSeatOther: '{n} additional seats',
      // Sprint 31, story-158 (house style §13.2/§13.6). `PlanSelectionCards` — the `count > 1`
      // (not `!== 1`) zero-handling bug named at this story's seven sites, fixed while converting.
      includedSeatOne: '{n} included seat',
      includedSeatOther: '{n} included seats',
      // Sprint 31, develop run 2 (priority 2/3). `SeatUsageModal` — untranslated, and its
      // `RolePills` were a raw-role-render site (fixed via `getTranslatedRoleLabel`).
      seatUsageModalTitle: 'Seat usage',
      seatsUsedSuffix: '{active} of {total} seats used',
      overSeatLimitCaption: "You're over your seat limit",
      noSeatsAvailableCaption: 'No seats available',
      seatsAvailableSuffix: '{n} available',
      billedPerSeatFooter: "You're billed per seat based on your plan.",
      allRolesCountFooter: 'Your plan counts every role toward a seat.',
      someRolesFreeFooter:
        'Your plan sets which roles use a seat. You can add these roles without using seats.',
      usesSeatHeading: 'Uses a seat',
      freeNoSeatHeading: 'Free — no seat',
      // Sprint 31, story-158 (house style §13.3/§13.4). `seatCountingRoles.ts`'s two sentence
      // builders — mid-sentence lowercase forms, distinct from `enumLabels.role*`'s capitalized
      // standalone forms (house style §9).
      roleAdminSingular: 'admin',
      roleAdminPlural: 'admins',
      roleOwnerSingular: 'owner',
      roleOwnerPlural: 'owners',
      roleProjectManagerSingular: 'project manager',
      roleProjectManagerPlural: 'project managers',
      roleSuperintendentSingular: 'superintendent',
      roleSuperintendentPlural: 'superintendents',
      roleCrewLeadSingular: 'crew lead',
      roleCrewLeadPlural: 'crew leads',
      roleEmployeeSingular: 'employee',
      roleEmployeePlural: 'employees',
      roleReviewerSingular: 'reviewer',
      roleReviewerPlural: 'reviewers',
      noSeatNoteOne: "The {role} doesn't use a seat.",
      noSeatNoteOther: "{roleList} don't use a seat.",
      seatWarningOne: "Remember, the {role} doesn't occupy seats.",
      seatWarningOther: "Remember, {roleList} don't occupy seats.",
      // English needs neither an article before each plural role nor the y/e alternation
      // (§11.3 is Spanish-only) — both are empty/plain 'and' here, real values in es.ts.
      roleListArticle: '',
      listConjunction: 'and',
      listConjunctionBeforeI: 'and',
    },
    paymentMethods: {
      title: 'Payment Methods',
      addButton: 'Add Payment Method',
      addFailedFallback: 'Failed to add payment method',
      lockedTitle: 'Your organization is locked — add a payment method to continue',
      lockedBodyPrefix: 'Your free trial has ended. Until a payment method is added,',
      lockedBodyEmphasis: 'every change is blocked',
      lockedBodySuffix:
        '— no new projects, tasks, clients or time entries can be saved, by you or by anyone on your team.',
      lockedDataSafe:
        'Your data is safe and still readable. Adding a card restores full access immediately.',
      addNowButton: 'Add Payment Method Now',
      noPaymentMethodsTitle: 'No Payment Methods',
      noPaymentMethodsBody:
        "You haven't added any payment methods yet. Add a payment method to manage your subscription.",
      defaultBadge: 'Default',
      expiresSuffix: 'Expires {month}/{year}',
      expSuffix: 'Exp {month}/{year}',
      setAsDefaultButton: 'Set as Default',
      deleteButtonTitle: 'Delete payment method',
      deleteModalTitle: 'Delete Payment Method',
      deleteConfirmBody: 'Are you sure you want to delete this payment method?',
      deleteWarning: 'This action cannot be undone.',
    },
    subscription: {
      pageTitle: 'Billing & Subscription',
      pageSubtitle: 'Manage your subscription, payment methods, and billing history',
      confirmPause: 'Are you sure you want to pause your subscription?',
      confirmStart:
        'Are you sure you want to start billing for your subscription? You will be charged on your next billing date.',
      organizationFallback: 'Organization',
      canceledTitle: 'Subscription canceled',
      canceledBodySuffix:
        'is now suspended and its team has lost access. Your data is kept in case you decide to come back.',
      continueButton: 'Continue',
      cancelSubscriptionButton: 'Cancel Subscription',
      undoneNoPeriod: 'This action cannot be undone',
      consequencesHeading: 'By canceling your subscription, you will:',
      consequenceGrandfatheringBold: 'Lose your grandfathering benefits.',
      consequenceGrandfatheringBody:
        'If you resubscribe later, you may be subject to different pricing.',
      consequenceAccessBold: 'Lose access to your organization.',
      consequenceAccessBody: 'Your data will not be deleted in case you decide to return.',
      consequenceEmployeesBold: 'All employees will be disabled.',
      consequenceEmployeesBody: 'Every team member will lose access immediately.',
      confirmTypePrefix: 'To confirm, type',
      confirmTypeSuffix: 'below:',
      confirmPlaceholder: 'Type "{org}" to confirm',
      mismatchPrefix: "That doesn't match. Type",
      mismatchSuffix: 'exactly to enable the button.',
      keepSubscriptionButton: 'Keep Subscription',
      noActiveSubscriptionTitle: 'No Active Subscription',
      noActiveSubscriptionBody:
        "You don't have an active subscription yet. Please contact support to set up your subscription.",
      activateOneStepTitle: 'One step left — activate your subscription',
      cardEndingPrefix: 'Your card ending in',
      cardEndingMiddle: 'is saved, but your organization is',
      stillReadOnlyEmphasis: 'still read-only',
      cardSavedTail:
        '. Saving a card does not start a subscription — activate it to restore full access for you and your team.',
      activateSubscriptionButton: 'Activate Subscription',
      activateModalTitle: 'Activate your subscription',
      activateModalDescription:
        'Your card ending in {last4} will be charged {price} per {period}, starting today. Full access is restored immediately.',
      activateAndPayButton: 'Activate and pay',
      notNowButton: 'Not now',
      paymentFailedTitle: 'Payment Failed',
      paymentFailedBody:
        'Your payment method was declined. Please update your payment information to continue using Zenhammer.',
      trialPeriodActiveTitle: 'Trial Period Active',
      trialEndsBodyPrefix: 'Your free trial ends on',
      trialEndsBodySuffix: "You won't be charged until after the trial period.",
      billingNotActiveTitle: 'Billing Not Active',
      billingNotActiveBodyPrefix: 'Your plan has been assigned but billing is not active yet.',
      billingNotActiveWithCard: 'Click "Start Billing" to activate your subscription.',
      billingNotActiveWithoutCard: 'Please add a payment method to start your subscription.',
      detailsTitle: 'Subscription Details',
      planAmountLabel: 'Plan & Amount',
      billedPrefix: 'Billed',
      periodAnnual: 'annual',
      periodMonthly: 'monthly',
      startDateLabel: 'Start Date',
      trialEndsLabel: 'Trial Ends',
      canceledAtLabel: 'Canceled At',
      seatsLabel: 'Seats',
      seatsUsedSuffix: '{active} of {total} used',
      seatsAvailablePrefix: "You're using {active} of {total} seats —",
      seatsAvailableSuffix: 'free.',
      seatsAllUsedMessage: 'All {total} seats are in use. Add seats to invite more people.',
      startBillingButton: 'Start Billing',
      addPaymentMethodToStartButton: 'Add Payment Method to Start',
      resumeSubscriptionButton: 'Resume Subscription',
    },
    history: {
      title: 'Billing History',
      loading: 'Loading...',
      noTransactionsTitle: 'No Transactions',
      noTransactionsBody: "You don't have any billing transactions yet.",
      transactionIdPrefix: 'Transaction ID:',
      loadMoreButton: 'Load More Transactions',
    },
  },
  // Sprint 28, story-144 (residual gap). pages/projects/components — remaining project-detail
  // subcomponents (budget cards, document manager, evidence tab, bill of materials).
  projectComponents: {
    budgetCard: {
      title: 'Budget',
      totalCost: 'Total Cost',
      maxBudget: 'Max Budget',
      progress: 'Progress',
      materials: 'Materials',
      details: 'Details',
    },
    timelineCard: {
      title: 'Timeline',
      start: 'Start',
      end: 'End',
      totalManHours: 'Total Man-Hours',
      progress: 'Progress',
      import: 'Import',
      schedule: 'Schedule',
      // Sprint 31, story-161. Third button beside Import.
      generateWithAi: 'Generate with AI',
      // Short visible label; `generateWithAi` stays as the button's tooltip / aria-label.
      ai: 'AI',
    },
    delegatedTasksTab: {
      colTaskName: 'Task Name',
      colDelegatedTo: 'Delegated To',
      colAcceptedBudget: 'Accepted Budget',
      emptyMessage: 'No delegated tasks with accepted budgets',
      totalDelegatedCost: 'Total Delegated Cost',
    },
    allItemsTab: {
      colCategory: 'Category',
      colNameDescription: 'Name / Description',
      colTotalCost: 'Total Cost',
      emptyMessage: 'No budget items',
      grandTotal: 'Grand Total',
      categoryMaterial: 'Material',
      categoryEquipment: 'Equipment',
      categoryDelegated: 'Delegated',
      categoryLineItem: 'Line Item',
    },
    budgetSummaryHeader: {
      onBudget: 'ON BUDGET',
      overBudget: 'OVER BUDGET',
      delegated: 'Delegated',
      owned: 'Owned',
      materialsCount: '{n} Materials',
      equipmentCount: '{n} Equipment',
      delegatedCount: '{n} Delegated',
      lineItemsCount: '{n} Line Items',
      materials: 'Materials',
      equipment: 'Equipment',
      delegatedLabel: 'Delegated',
      lineItems: 'Line Items',
      from: 'From:',
      client: 'Client:',
      pm: 'PM:',
      supt: 'Supt:',
      budget: 'Budget:',
      spent: 'Spent:',
    },
    documents: {
      addDocuments: 'Add Documents',
      manageAllDocuments: 'Manage all documents',
      categoryLabel: 'Category: {category}',
      kbOf: '{used} KB of {total} KB • Uploading…',
      completed: 'Completed',
      uploadFailed: 'Upload failed',
      uploadDisabled: 'Upload is disabled',
      uploadingFiles: 'Uploading files...',
      dropFilesHere: 'Drop files here…',
      chooseOrDrag: 'Choose a file or drag & drop it here.',
      selectCategoryFirstHint: 'Select a category above to enable file upload',
      acceptedFormatsHint: 'JPEG, PNG, PDF, and MP4 formats, up to 50 MB.',
      browseFile: 'Browse File',
      done: 'Done',
      manageDocumentsTitle: 'Manage Documents',
      manageDocumentsDescription:
        'Upload and manage documents for your project. You can also add categories to your documents to help you organize them.',
      categoryFieldLabel: 'Category',
      selectCategoryPlaceholder: 'Select a category',
      selectCategoryFirst: 'Select a category first',
      dropDocumentsHere: 'Drop documents here, or click to select',
      documentsSubtitle: 'PDF, TXT, CSV, images up to 50MB each',
      pleaseSelectCategory: 'Please select a category',
    },
    evidenceTab: {
      loadError: "Couldn't load evidence — please try again.",
      noTasksYet: 'No tasks yet — evidence appears here once tasks are created.',
    },
    billOfMaterials: {
      title: 'Bill of Materials',
      fullProject: 'Full Project',
      detailedByTask: 'Detailed by Task',
      printExport: 'Print / Export',
      generated: 'Generated: {date}',
      view: 'View: {mode}',
      totalItems: 'Total Items',
      materials: 'Materials',
      equipment: 'Equipment',
      totalCost: 'Total Cost',
      close: 'Close',
    },
  },
  // Sprint 28, story-144 (residual gap). pages/projects/components/ProjectFeed — 14 activity-card
  // renderers. Shared field labels live at the top level; per-card copy is nested.
  // Sprint 31, story-149 (Instance 1). Renamed from `projectFeed` to adopt mobile's two-section
  // split (`activityCards`/`activityFeed`) as the canonical shape — mobile already separated
  // per-card fields from feed-container chrome; `noActivitiesToDisplay`/`noMoreActivities` moved
  // out to the new `activityFeed` section below. Pure rename/split, values unchanged.
  activityCards: {
    taskLabel: 'Task:',
    projectLabel: 'Project:',
    notAvailable: 'N/A',
    taskTypeLabel: 'Task Type:',
    createdByLabel: 'Created by {org}',
    maxBidLabel: 'Max Bid:',
    timelineLabel: 'Timeline:',
    sentToLabel: 'Sent to:',
    byLabel: 'By',
    crewAssign: {
      crewAssigned: 'Crew Assigned',
    },
    delegationCanceled: {
      taskDelegationCancelled: 'Task Delegation Cancelled',
      delegationCancelledPanel: 'Delegation Cancelled',
      availableForReassignmentHint:
        'This task is now available for reassignment to your team or for sending budget requests.',
      description:
        'The delegation for this task has been cancelled and the task is now available for reassignment.',
    },
    note: {
      addedNote: 'Added note - {time}',
      attemptedAt: '↳ Attempted at - {time}',
      attachments: 'Attachments ({n})',
    },
    communication: {
      communication: 'Communication',
      communicationTime: 'Communication - {time}',
      documentFallback: 'Document',
    },
    taskStatus: {
      statusActive: 'Active task',
      statusInactive: 'Inactive task',
      statusComplete: 'Completed task',
      statusRejected: 'Rejected task',
      statusCanceled: 'Canceled task',
      statusInternalApproval: 'Internal Approval task',
      statusClientApproval: 'Client Approval task',
      statusDelegationCanceled: 'Delegation Canceled task',
      rejectionReason: 'Rejection Reason',
    },
    budgetRequestRejected: {
      bidProposalRejected: 'Bid Proposal Rejected',
    },
    budgetProposalCountered: {
      bidProposalCountered: 'Bid Proposal Countered',
      biddProposalCounteredBy: 'Bid Proposal Countered by {org}',
      originalProposalLabel: 'Original Proposal:',
      originalRequestBy: 'Original Request by {org}',
      requestedTimelineLabel: 'Requested Timeline:',
      originalRequestDescriptionLabel: 'Original Request Description:',
    },
    budgetProposalAccepted: {
      bidProposalAccepted: 'Bid Proposal Accepted',
      acceptedAmountLabel: 'Accepted Amount:',
    },
    budgetRequestCreated: {
      bidRequestCreated: 'Bid Request Created',
    },
    budgetRequestSubmitted: {
      bidProposalSubmitted: 'Bid Proposal Submitted -',
      proposedSubmittedBy: 'Proposed submitted by {org}',
    },
    budgetRequestAccepted: {
      bidRequestAccepted: 'Bid Request Accepted',
    },
    geofence: {
      geofenceButton: 'Geofence',
      enter: 'ENTER',
      exit: 'EXIT',
    },
    invoicePending: {
      pendingToInvoice: 'Pending to invoice',
      equipmentSingular: 'Equipment',
      equipmentPlural: 'Equipments',
      materialSingular: 'Material',
      materialPlural: 'Materials',
      noPendingItems: 'No pending items',
      resolved: 'Resolved',
      createInvoice: 'Create Invoice',
      awaitingInvoicing: 'Awaiting invoicing by manager',
      defaultTaskName: 'Task',
    },
    punchClock: {
      clockedIn: 'Clocked In',
      clockedOut: 'Clocked Out',
      userLabel: 'User:',
      defaultUser: 'User',
      geofenceButton: 'Geofence',
    },
    incident: {
      incidentAcknowledged: 'Incident Acknowledged',
      incidentReported: 'Incident Reported',
      attemptedAt: '↳ Attempted at - {time}',
      incidentLabel: 'Incident:',
      affectedTasksLabel: 'Affected Tasks:',
      acknowledgedLabel: 'INCIDENT ACKNOWLEDGED',
      acknowledgedByLabel: 'Acknowledged by:',
      originalIncidentLabel: 'Original Incident:',
      typeLabel: 'Type:',
      clickToAcknowledge: 'Click to acknowledge this incident',
      clickToAcknowledgeBadge: 'Click to Acknowledge',
      timeOfIncident: 'Time of Incident: {time}',
      delayLabel: 'Delay:',
      statusLabel: 'Status:',
      // Sprint 28 change request (story-144 History, defect fix). `IncidentStatus`
      // (backend/src/entities/incident/incident.entity.ts) has exactly these two values — the
      // status pill at this card's `statusLabel` was rendering `incident.status` raw instead of
      // going through a translated map.
      statusPending: 'Pending',
      statusAcknowledged: 'Acknowledged',
      acknowledgeButton: 'Acknowledge',
      needsAttentionHint:
        'This incident requires your attention. Click the badge above or the acknowledge button to review and acknowledge.',
      attachments: 'Attachments ({n})',
      documentFallback: 'Document',
      // Sprint 28 change request (story-144 History, fifth-site defect fix). `AcknowledgeIncidentModal`
      // (web + mobile) was entirely unwired for i18n — every string below is new for that migration,
      // reusing this same `incident` subsection rather than inventing a separate one, since the modal
      // renders largely the same fields as `ActivityIncident`/`ActivityIncidentCard` above.
      incidentDetailsTitle: 'Incident Details',
      detailsSectionLabel: 'Details',
      reportedByLabel: 'Reported by:',
      unknownTypeFallback: 'Unknown',
      todayAtPrefix: 'Today at {time}',
      dateAtTimeFormat: '{date} at {time}',
      acknowledgedOnPrefix: 'on {date}',
      acknowledgeConfirmTitle: 'Acknowledge this incident?',
      acknowledgeConfirmBody:
        'This action will mark the incident as acknowledged and record that you have reviewed this alert. Other users will be able to see that you have acknowledged this incident. This action cannot be undone.',
      acknowledgeIncidentButton: 'Acknowledge Incident',
      acknowledgingButton: 'Acknowledging...',
    },
  },
  // Sprint 31, story-149 (Instance 1). Extracted from `projectFeed` (now `activityCards`) —
  // feed-container loading/empty-state chrome, mirroring mobile's `activityFeed` section
  // (`redesign/src/i18n/en.ts`) key-for-key.
  activityFeed: {
    noActivitiesToDisplay: 'No activities to display',
    noMoreActivities: 'No more activities',
  },
  // Sprint 28, story-142. Web-only — the CREW_LEAD/EMPLOYEE `/home` landing page has no mobile
  // equivalent (those roles go straight into the app on mobile). See docs/architecture.md
  // "## Sprint 28" Decision 1.
  home: {
    welcomeTitle: 'Welcome to ZenHammer web panel',
    useMobileApp:
      'If you log in as an Employee or Crew Lead, please use the mobile app for the best experience.',
    logout: 'Log Out',
  },
  // Sprint 28, story-143. Post-auth organization/account-lifecycle pages (Bucket 2 — render in
  // the user's stored locale, never re-detected). See docs/architecture.md "## Sprint 28"
  // Decision 4 and docs/ux/story-143-design.md.
  orgLifecycle: {
    checkingAccountStatus: 'Checking account status...',
    userDisabledTitle: 'Account Disabled',
    userDisabledMessage:
      'Your account has been disabled in all your organizations. Please contact an administrator to regain access.',
    whatCanYouDo: 'What can you do?',
    userDisabledBulletAdmin:
      'Contact your organization administrator to request account reactivation',
    userDisabledBulletSupport: 'If you believe this is a mistake, reach out to our support team',
    userDisabledBulletTryAgain: 'Once reactivated, click "Try Again" to access the system',
    userDisabledBulletNewOrg: 'Create a new organization to start fresh',
    createNewOrganization: 'Create New Organization',
    tryAgain: 'Try Again',
    contactSupport: 'Contact Support',
    needHelp: 'Need help? Email us at support@zenhammer.com',
    noOrganizationTitle: "You're not part of an organization yet",
    noOrganizationMessage:
      'Ask an administrator to invite you, or create your own organization to get started.',
    noOrganizationHint:
      'Create your own organization to start using Zenhammer, or wait for an invitation from your team.',
    createAnOrganization: 'Create an Organization',
    checking: 'Checking...',
    checkForOrganization: 'Check for Organization',
    organizationFoundRedirecting: 'Organization found! Redirecting...',
    noOrganizationFoundYet: 'No organization found yet. Please check your email or create one.',
    failedToCheckOrganization: 'Failed to check for organization',
    organizationCreatedRedirecting: 'Organization created successfully! Redirecting...',
    organizationCreatedNotAssigned:
      'Organization created but not assigned to user. Please refresh the page.',
    failedToLoadOrganization: 'Failed to load organization. Please refresh the page.',
    expectingInvitationHint:
      "If you're expecting an invitation, please check your email inbox and spam folder.",
    pullToRefreshHint: "Pull down to refresh and check if you've been added to an organization.",
    organizationDisabledTitle: 'Your organization has been disabled',
    organizationDisabledMessage: 'Contact your administrator for more information.',
    organizationSuspendedTitle: 'Organization Suspended',
    organizationSuspendedMessage: 'Your organization has been suspended due to a payment issue.',
    checkingOrganizationStatus: 'Checking organization status...',
    ownerReactivateHint:
      'As the organization owner, you can reactivate your subscription by providing a new payment method, or create a new organization.',
    reactivateSubscription: 'Reactivate Subscription',
    reactivateRestoreHint:
      'Reactivating your subscription will restore access to your organization and all its data.',
    nonOwnerSuspendedHint:
      'Please contact your organization administrator to resolve this issue, or create your own organization to continue using Zenhammer.',
    nonOwnerErrorHint: 'If you believe this is an error, please contact your organization owner or administrator.',
    nonOwnerBillingHint: 'They can update the payment method in the billing settings.',
    reactivateSubscriptionFor: 'Reactivate subscription for {org}',
    reactivateFailedError: 'Failed to reactivate subscription. Please try again.',
    reactivateInfoBanner:
      'Your organization {org} has been suspended. Complete the form below to reactivate your subscription and restore access.',
    activeOrganizationsHeading: 'You have active organizations:',
    switchOrganization: 'Switch',
    suspendedOrganizationsHeading: 'Suspended organizations you can reactivate:',
    suspendedBadge: 'Suspended',
    reactivate: 'Reactivate',
    disabledOrganizationsHeading: 'Organizations where your account is disabled:',
    disabledBadge: 'Disabled',
    contactAdmin: 'Contact admin',
    trialExpiredTitle: 'Your free trial has ended',
    trialExpiredMessage: 'Subscribe to keep using ZenHammer without interruption.',
    nothingToDoHere: 'Nothing to do here',
    subscriptionGoodStanding: "This organization's subscription is in good standing.",
    backToDashboard: 'Back to dashboard',
    trialEndedForOrg: 'The free trial for {org} has ended',
    teamCanStillOpen:
      'Your team can still open and read everything — projects, tasks, documents and photos are all intact. Creating and editing are paused until the account owner adds a payment method.',
    onlyOwnerCanRestore: 'Only the account owner can do that, so reach out to them to restore full access.',
    choosePlanForOrg: 'Choose a plan for {org}',
    trialEndedAddPayment:
      'Your free trial has ended. Nothing was deleted — add a payment method and full access comes back right away.',
    paymentCouldNotBeProcessed: 'Payment could not be processed',
    activateSubscriptionError: 'Could not activate the subscription. Please check the card details and try again.',
    planLabel: 'Plan',
    paymentDetails: 'Payment details',
    back: 'Back',
    activateSubscription: 'Activate subscription',
    logout: 'Logout',
  },
  // Sprint 30, story-151. One shared glossary for all 8 ConstructionCalculatorsModal
  // calculators plus CalculatorSelector.tsx (docs/architecture.md Sprint 30) — every one of
  // those 16 files calls `useTranslation('calculators')` and only that; a term already
  // decided here (dimensions/materials/actions/counts) is referenced, never re-declared per
  // calculator. Unit/trade symbols (ft, in, yd, lb, PSI, AWG, GPM, WSFU) are intentionally NOT
  // here — they live in `web/src/app/utils/calculatorUnits.ts` (house style §10.1,
  // language-invariant symbols never routed through this catalog).
  calculators: {
    names: {
      concrete: 'Concrete Calculator',
      concreteDescription: 'Calculate concrete volume for various structures',
      plumbing: 'Plumbing Calculator',
      plumbingDescription: 'Nodal flow analysis with friction loss calculations',
      electrical: 'Electrical Calculator',
      electricalDescription: 'NEC compliant wire sizing, breakers, and BOM',
      retainingWall: 'Retaining Wall Calculator',
      retainingWallDescription: 'Calculate blocks and gravel for retaining walls',
      tile: 'Tile Calculator',
      tileDescription: 'Calculate tiles, grout, and boxes needed',
      flooring: 'Flooring Calculator',
      flooringDescription: 'Calculate flooring materials and boxes needed',
      paint: 'Paint Calculator',
      paintDescription: 'Calculate paint gallons needed for room painting',
      framing: 'Framing Calculator',
      framingDescription: 'Calculate studs and plates for wall framing',
      selectCalculator: 'Select Calculator',
      selectCalculatorPlaceholder: 'Select a calculator...',
    },
    dimensions: {
      length: 'Length',
      lengthFt: 'Length (ft)',
      width: 'Width',
      widthFt: 'Width (ft)',
      height: 'Height',
      heightFt: 'Height (ft)',
      thickness: 'Thickness',
      thicknessIn: 'Thickness (in)',
      diameter: 'Diameter',
      diameterIn: 'Diameter (in)',
      wasteAllowancePct: 'Waste Allowance (%)',
      roomDimensionsFt: 'Room Dimensions (in feet)',
      roomArea: 'Room Area:',
      cubicYards: 'cubic yards',
      sqFt: 'sq. ft.',
      wallLengthFt: 'Wall Length (ft)',
    },
    materials: {
      concrete: 'Concrete',
      rebar: 'Rebar',
      mortar: 'Mortar',
      gravel: 'Gravel',
      tile: 'Tile',
      grout: 'Grout',
      paint: 'Paint',
      primer: 'Primer',
      framingLumber: 'Framing lumber',
      conduit: 'Conduit',
      pipe: 'Pipe',
      pipeIndividual: 'Pipe',
      wire: 'Wire',
      wireGauge: 'Wire gauge',
      retainingWall: 'Retaining wall',
      studs: 'Studs',
      plates: 'Plates',
      // Sprint 30 change request (story-151 QA re-review). `FlooringCalculator` had no material
      // noun of its own — `names.flooring`/`flooringDescription` name the calculator, not the
      // material it produces.
      flooring: 'Flooring',
    },
    actions: {
      calculate: 'Calculate',
      clear: 'Clear',
      result: 'Result',
      results: 'Results',
      addToMaterial: 'Add to Material',
      add: 'Add',
      addRun: 'Add Run',
      cancel: 'Cancel',
      deleteRun: 'Delete run',
      note: 'Note:',
      addAllMaterials: 'Add All Materials',
      items: 'items',
      billOfMaterialsSummary: 'Bill of Materials Summary',
      coverage: 'Coverage',
      examplePrefix: 'e.g.',
    },
    counts: {
      doors: 'Number of Doors',
      windows: 'Number of Windows',
      corners: 'Number of Corners',
      coats: 'Number of Coats',
      steps: 'Number of Steps',
    },
    concrete: {
      selectWhatToCalculate: 'Select what to calculate:',
      concreteNeeded: 'Concrete Needed:',
      // Sprint 30, story-151 review Critical #2. `concreteTypeOptions`/`columnShapeOptions` were
      // a hardcoded `SelectOption[]` array, invisible to the guard's object-literal-only check.
      types: {
        slab: 'Slab',
        sidewalk: 'Sidewalk',
        footer: 'Footer',
        column: 'Column',
        tube: 'Tube',
        stairs: 'Stairs',
        curb: 'Curb',
        gutterBarrier: 'Gutter Barrier',
      },
      shapes: {
        round: 'Round',
        square: 'Square / Rectangular',
      },
      riserHeightIn: 'Riser Height (in)',
      treadDepthIn: 'Tread Depth (in)',
      stepWidthFt: 'Step Width (ft)',
      columnShape: 'Column Shape',
      side1In: 'Side 1 (in)',
      side2In: 'Side 2 (in)',
      wallThicknessIn: 'Wall Thickness (in)',
      curbDepthIn: 'Curb Depth (in)',
      curbHeightIn: 'Curb Height (in)',
      gutterWidthIn: 'Gutter Width (in)',
      flagThicknessIn: 'Flag Thickness (in)',
      // Sprint 30 change request (story-151 QA re-review, Bug #1). `getCalculationTypeLabel()`
      // returned these 9 strings from a plain `switch`, invisible to the guard (a switch-return
      // is not an object literal — see docs/architecture.md's blind-spot #3). Each is its own
      // full catalog string, not `"{type} " + "Dimensions"` concatenation, since Spanish word
      // order needs "Dimensiones de la losa," not "Losa Dimensiones."
      dimensionsHeadingSlab: 'Slab Dimensions',
      dimensionsHeadingSidewalk: 'Sidewalk Dimensions',
      dimensionsHeadingFooter: 'Footer Dimensions',
      dimensionsHeadingStairs: 'Stair Dimensions',
      dimensionsHeadingColumn: 'Column Dimensions',
      dimensionsHeadingTube: 'Tube Dimensions',
      dimensionsHeadingCurb: 'Curb Dimensions',
      dimensionsHeadingGutterBarrier: 'Gutter Barrier Dimensions',
      dimensionsHeadingDefault: 'Dimensions',
    },
    retainingWall: {
      wallBlockDimensions: 'Wall & Block Dimensions',
      wallHeightFt: 'Wall Height (ft)',
      blockLengthIn: 'Block Length (in)',
      blockHeightIn: 'Block Height (in)',
      includeCapRow: 'Include a cap row?',
      gravelBackfill: 'Gravel Backfill',
      wallBlocks: 'Wall Blocks:',
      capBlocks: 'Cap Blocks:',
      totalBlocks: 'Total Blocks:',
      gravelNeeded: 'Gravel Needed:',
      gravelWeight: 'Gravel Weight:',
      // Sprint 30 change request (story-151 QA re-review, Bug #2). A clean (no trailing colon)
      // material name for `onAddToMaterial`'s `suggestedName` — `wallBlocks` above is a row
      // label, not a material name.
      wallBlocksMaterial: 'Wall Blocks',
      // Sprint 30 change request (story-151 review addendum — class sweep). Same bare
      // JSX-text-sibling shape as `paint.unitGallonOne`; one pair reused across all three
      // result rows (Wall/Cap/Total Blocks) below, all counting the same noun.
      blocksUnitOne: 'block',
      blocksUnitOther: 'blocks',
    },
    tile: {
      tileAndGroutDimensions: 'Tile and Grout Dimensions',
      tileLengthIn: 'Tile Length (in inches)',
      tileWidthIn: 'Tile Width (in inches)',
      groutJointWidthIn: 'Grout Joint Width (in inches)',
      additionalInformation: 'Additional Information',
      tilesPerBox: 'Tiles per Box',
      calculateButton: 'Calculate Tiles & Grout',
      tilesNeeded: 'Approximate Tiles Needed:',
      groutNeeded: 'Grout Needed:',
      groutNeededUnit: 'lbs (approx.)',
      boxesOfTiles: 'Boxes of Tiles:',
      // Sprint 30 change request (story-151 QA re-review, Bug #2). Clean material name for
      // `onAddToMaterial`'s `suggestedName` — `boxesOfTiles` above is a row label, not a name.
      tileBoxesMaterial: 'Tile Boxes',
      // Sprint 30 change request (story-151 review addendum — class sweep). Same bare
      // JSX-text-sibling shape as `paint.unitGallonOne`, at two result rows in this file.
      tilesUnitOne: 'tile',
      tilesUnitOther: 'tiles',
      boxesUnitOne: 'box',
      boxesUnitOther: 'boxes',
    },
    flooring: {
      wasteAndBoxInformation: 'Waste & Box Information',
      sqftPerBox: 'Sq. Ft. per Box',
      woodPlankDimensions: 'Wood Plank Dimensions (Optional)',
      plankLengthIn: 'Plank Length (in inches)',
      plankWidthIn: 'Plank Width (in inches)',
      calculateButton: 'Calculate Flooring',
      flooringNeeded: 'Flooring Needed:',
      boxesNeeded: 'Boxes Needed:',
      planksNeeded: 'Approximate Planks Needed:',
      // Sprint 30 change request (story-151 QA re-review, Bug #2). Clean material names for
      // `onAddToMaterial`'s `suggestedName` (the `*Needed` keys above are row labels).
      flooringBoxesMaterial: 'Flooring Boxes',
      flooringPlanksMaterial: 'Flooring Planks',
      // Sprint 30 change request (story-151 review addendum — class sweep). Same bare
      // JSX-text-sibling shape as `paint.unitGallonOne`, at two result rows in this file.
      boxesUnitOne: 'box',
      boxesUnitOther: 'boxes',
      planksUnitOne: 'plank',
      planksUnitOther: 'planks',
    },
    paint: {
      doorsAndWindowsCount: 'Doors & Windows (count)',
      paintInformation: 'Paint Information',
      coverageSqFtGallon: 'Coverage (sq ft / gallon)',
      calculateButton: 'Calculate Paint',
      totalPaintableArea: 'Total Paintable Area:',
      gallonsNeeded: 'Gallons Needed:',
      // Sprint 30 change request (story-151 QA re-review, Bug #3). The result row rendered the
      // computed value followed by the bare English word "gallons" as a JSX-text sibling — a
      // single lowercase token with no whitespace, the guard's own carve-out for
      // camelCase-ish/CSS-class-shaped tokens, so no content rule ever inspected it. Count-based
      // per house style §11.1's ratified `xOne`/`xOther` shape.
      unitGallonOne: 'gallon',
      unitGallonOther: 'gallons',
    },
    framing: {
      wallInformation: 'Wall Information',
      wallLengthInFeet: 'Wall Length (in feet)',
      studSpacingIn: 'Stud Spacing (in inches)',
      openingsAndCorners: 'Openings & Corners',
      calculateButton: 'Calculate Framing',
      totalStudsNeeded: 'Total Studs Needed:',
      totalPlateLumber: 'Total Plate Lumber:',
      plateLumberUnit: 'linear feet (assuming 3 plates)',
      // Sprint 30 change request (story-151 QA re-review, Bug #2). Clean material names for
      // `onAddToMaterial`'s `suggestedName` (the `total*` keys above are row labels).
      wallStudsMaterial: 'Wall Studs',
      plateLumberMaterial: 'Plate Lumber',
      // Sprint 30 change request (story-151 review addendum — class sweep). Bare English
      // JSX-text-sibling word next to a computed value, same shape as `paint.unitGallonOne`.
      // Count-based per house style §11.1's ratified `xOne`/`xOther` shape.
      studsUnitOne: 'stud',
      studsUnitOther: 'studs',
    },
    plumbing: {
      subtitle: 'Nodal Flow Analysis with Hazen-Williams Friction Loss',
      // Sprint 30, story-151 review Critical #4. These 2 arrays plus the default run label were
      // module-level/inline hardcoded English, invisible to the guard's object-literal-only
      // check (arrays) or simply never wired to `tCalc` (the default label). `PEX` is kept
      // unchanged, same reasoning as AWG/PSI/GPM/WSFU (§10.1) — a plastics-industry material
      // code with no Spanish equivalent in trade use; `value` fields throughout are unchanged
      // (they are `PipeMaterial`/`FixtureType` literal union members read elsewhere as data
      // keys), only the rendered `label` moves to Spanish.
      materialCopperL: 'Copper Type L',
      fixtureToiletHe: 'Toilet (HE)',
      fixtureShower: 'Shower',
      fixtureKitchenSink: 'Kitchen Sink',
      fixtureLavatory: 'Lavatory',
      fixtureGardenTub: 'Garden Tub',
      mainTrunk: 'Main Trunk',
      sourcePressurePsi: 'Source Pressure (PSI)',
      allRunsAdequatePressure: 'All Runs Have Adequate Pressure',
      someRunsLowPressure: 'Some Runs Have Low Pressure',
      pipeRuns: 'Pipe Runs',
      newPipeRun: 'New Pipe Run',
      runLabel: 'Run Label',
      exampleRunLabel: 'e.g., Bathroom Branch',
      pipeMaterial: 'Pipe Material',
      pipeSize: 'Pipe Size',
      fixtureType: 'Fixture Type',
      fixtureCount: 'Fixture Count',
      elbows90: '90° Elbows',
      elbows45: '45° Elbows',
      teesLineBranch: 'Tees (Line/Branch)',
      teeLinePlaceholder: 'Line',
      teeBranchPlaceholder: 'Branch',
      supply: 'Supply',
      size: 'Size',
      fixture: 'Fixture',
      elbows9045: '90° / 45° Elbows',
      endPressure: 'End Pressure',
      effectiveLength: 'Effective Length:',
      pipeInventory: 'Pipe Inventory',
      fittingInventory: 'Fitting Inventory',
      teeFittings: 'Tee Fittings',
      // Sprint 30, story-151 review addendum (retry 1). Found by the Developer's own
      // triage sweep, not named in the review — a hardcoded literal baked directly into
      // `results.runs[].failReason` (a computed-string blind spot, same class as the
      // switch-return/ternary shapes already fixed this sprint), rendered verbatim on
      // both surfaces. Identical bug and identical fix on `redesign`.
      criticalPressureDrop: 'Critical Pressure Drop',
      engineeringNote:
        'A Branch-flow Tee creates 6x the friction of a Line-flow Tee. Use straight-through lines for main trunks to preserve head pressure. Minimum recommended end pressure is 30 PSI.',
      // Sprint 30 change request (story-151 review addendum — class sweep). Same bare
      // JSX-text-sibling shape as `paint.unitGallonOne`; one pair reused across the three
      // fitting-inventory rows (elbows90, elbows45, teeFittings) below.
      fittingUnitOne: 'unit',
      fittingUnitOther: 'units',
    },
    electrical: {
      subtitle: 'NEC 2023 Compliant Wire Sizing & BOM Calculator',
      // Sprint 30, story-151 review Critical #3. These 5 arrays were module-level hardcoded
      // `SelectOption[]` — invisible to the guard's object-literal-only check. `value` fields are
      // not translated (they are `WireMaterial`/`WireType`/`ProtectionType`/`AmbientTemp` literal
      // union members read elsewhere as data keys); only the rendered `label` moves to Spanish.
      materialCopper: 'Copper',
      materialAluminum: 'Aluminum',
      // Sprint 30, story-151 re-review Critical #1. Default first-run label, mirroring
      // `calculators.plumbing.mainTrunk`'s pattern for the identical shape (a `useState`
      // initializer string, not a table or JSX literal).
      kitchenCircuit: 'Kitchen Circuit',
      wireTypeThhn: 'THHN (Conduit)',
      protectionStandard: 'Standard',
      protectionDual: 'Dual (GFCI + AFCI)',
      ambientStandard: 'Standard (86°F)',
      ambientWarm: 'Warm (104°F)',
      ambientHotAttic: 'Hot Attic (122°F)',
      ambientExtreme: 'Extreme (140°F)',
      maxDropRecommended: '2% (Recommended)',
      maxDropNecMax: '3% (NEC Max)',
      maxVoltageDropAllowed: 'Max Voltage Drop Allowed',
      allRunsSafe: 'All Runs Safe',
      someRunsNeedAttention: 'Some Runs Need Attention',
      wireRuns: 'Wire Runs',
      newWireRun: 'New Wire Run',
      circuitLabel: 'Circuit Label',
      wireMaterial: 'Wire Material',
      exampleCircuitLabel: 'e.g., Kitchen Circuit',
      voltage: 'Voltage',
      loadCurrentA: 'Load Current (A)',
      runLengthFt: 'Run Length (ft)',
      wireType: 'Wire Type',
      protectionType: 'Protection Type',
      ambientTemperature: 'Ambient Temperature',
      autoFixWireGauge: 'Auto-fix wire gauge',
      gauge: 'Gauge',
      current: 'Current',
      typeLabel: 'Type',
      temp: 'Temp',
      protection: 'Protection',
      dropSuffix: 'Drop',
      breaker: 'Breaker:',
      limit: 'Limit:',
      cond: 'Cond:',
      wireInventory: 'Wire Inventory',
      conduitTenFtSticks: 'Conduit (10ft Sticks)',
      sticksLabel: 'sticks',
      breakers: 'Breakers',
      // Sprint 30 change request (story-151 QA re-review, Bug #2). Clean material-name word for
      // `onAddToMaterial`'s `suggestedName`/`resultLabel` (`breaker` above is a row label with a
      // trailing colon).
      breakerMaterial: 'Breaker',
    },
  },
  // Sprint 30, story-152. Warehouse/inventory hotspot cluster — non-enum operational prose.
  // Enum display text (AdjustmentReason, TransactionStatus, TaskEquipmentStatus, etc.) lives in
  // `enumLabels`, not here (docs/architecture.md Sprint 30, mirroring story-148's split).
  warehouse: {
    // Sprint 30 change request (story-152 QA re-review, Bugs #2/#3). One shared generic-unit
    // pair, reused everywhere `material.unit || 'units'` (plural, quantity contexts) or
    // `material.unit || 'unit'` (singular, per-unit rate contexts) was hardcoded — confirmed at
    // 11 occurrences in `AdjustStockModal`, 5 in `ReceiveStockModal`, and more in
    // `StockOverviewDashboard`/`reports-valuation.tsx`. One catalog key per grammatical number,
    // not six independent fixes.
    genericUnitPlural: 'units',
    genericUnitSingular: 'unit',
    // Shared across AdjustStockModal + ReceiveStockModal (both have a "Material Selection"
    // step with an identical search field and identical Warehouse/Quantity fields).
    materialSelection: 'Material Selection',
    selectMaterialRequired: 'Select Material *',
    searchOrSelectMaterial: 'Search or select material...',
    noMaterialsFound: 'No materials found',
    warehouseRequired: 'Warehouse *',
    // Sprint 30, story-152 review Critical #7. Unstarred variant of `warehouseRequired` for the
    // conditional-star label `Warehouse${wantsInitialStock ? ' *' : ''}`, which previously
    // hardcoded the bare word instead of reusing the section's own existing term.
    warehouseLabel: 'Warehouse',
    selectWarehousePlaceholder: 'Select warehouse...',
    currentStock: 'Current Stock',
    reorderPoint: 'Reorder Point',
    quantityRequired: 'Quantity *',
    detailsRequired: 'Details *',
    resultPreview: 'Result Preview',
    afterAdjustment: 'After Adjustment',
    criticalLowStockWarning: 'Critical Low Stock Warning',
    foundExtraInventory: 'Found extra inventory',
    damagedLostStolen: 'Damaged, lost, or stolen',
    receiveStock: 'Receive Stock',
    adjustment: {
      title: 'Adjust Stock',
      description: 'Make corrections to inventory counts',
      // Sprint 30, story-152 review Critical #2. Previously a hardcoded ternary in a `confirmText`
      // prop — `checkJsxAttribute` only unwrapped a `JsxExpression` whose inner expression was
      // directly a `StringLiteral`; a `ConditionalExpression` was neither, so both branches were
      // invisible regardless of content.
      applying: 'Applying...',
      applyAdjustment: 'Apply Adjustment',
      warningIntro:
        'Stock adjustments should only be used for corrections (damaged, lost, found, count errors). Use',
      warningMiddle: 'for new inventory and',
      taskConsumptionLink: 'task consumption',
      warningEnd: 'for normal usage.',
      details: 'Adjustment Details',
      typeLabel: 'Adjustment Type *',
      addToStock: 'Add to Stock',
      removeFromStock: 'Remove from Stock',
      quantityExceedsStock: 'Quantity exceeds current stock. Maximum removal:',
      reasonForAdjustment: 'Reason for Adjustment',
      selectReasonPlaceholder: 'Select reason...',
      describeReasonPlaceholder: 'Describe the reason for this adjustment...',
      noteAuditPurposes: 'This note will be saved for audit purposes',
      adding: 'Adding',
      removing: 'Removing',
      afterAdjustmentStockAt: 'After this adjustment, stock will be at',
      considerOrderingMore: 'Consider ordering more stock soon.',
      cannotRemoveMoreThanStock: 'Cannot remove more than current stock (',
      toStock: 'to stock',
      fromStock: 'from stock',
      belowReorderPointOf: 'which is below the reorder point of',
      pleaseReduceQuantity: 'Please reduce the quantity.',
    },
    receiptTotal: 'Receipt Total',
    afterReceipt: 'After Receipt',
    currentAvgCost: 'Current Avg Cost',
    newAvgCost: 'New Avg Cost',
    weightedAverageCost: 'Weighted Average Cost',
    receive: {
      description: 'Record incoming materials to your warehouse',
      // Sprint 30, story-152 review Critical #3. Previously a hardcoded ternary in a
      // `confirmText` prop, same blind spot as `AdjustStockModal`'s Critical #2.
      receiving: 'Receiving...',
      avgCost: 'Avg Cost',
      supplier: 'Supplier',
      receiptDetails: 'Receipt Details',
      unitCostRequired: 'Unit Cost *',
      lastCost: 'Last cost:',
      enterSupplierPlaceholder: 'Enter supplier name...',
      batchReference: 'Batch Reference (PO/Invoice)',
      exampleBatchRef: 'e.g., PO-2025-0043',
      notes: 'Notes',
      notesPlaceholder: 'Additional notes about this receipt...',
      summary: 'Summary',
      fromCurrent: 'from current',
      receivedSuccess: 'Stock received successfully',
      receiveFailed: 'Failed to receive stock',
    },
    unitCost: 'Unit Cost',
    reference: 'Reference',
    alerts: {
      totalItems: 'Total Items',
      lowStockAlerts: 'Low Stock Alerts',
      totalValue: 'Total Value',
      reservedValue: 'Reserved Value',
      orderBy: 'Order By',
      taskStarts: 'Task Starts',
      supplier: 'Supplier',
      viewTask: 'View Task',
      reserve: 'Reserve',
      leadTimeSuffix: '(Lead time: {n} days)',
      orderTimeline: 'Order Timeline',
      orderByMarker: 'Order by',
      today: 'Today',
      taskStartsMarker: 'Task starts',
      availableStock: 'Available Stock',
      needMore: 'Need {n} more',
      warehouseLabel: 'Warehouse',
      leadTime: 'Lead Time',
      workingDays: 'working days',
      calendarDaysToTask: 'calendar days to task',
      materialOrderDeadlines: 'Material Order Deadlines',
      materialOrderDeadlinesSubtitle: 'Planned materials approaching their order deadline',
      overdue: 'Overdue',
      urgentOrderSoon: 'Urgent - Order Soon',
      upcoming: 'Upcoming',
      reserveMaterialTitle: 'Reserve Material',
      receiveReserveFailWarn:
        'Stock received but could not reserve material for the task. There may not be enough available stock.',
      reserveFailWarn: 'Could not reserve material. There may not be enough available stock.',
      taskLabel: 'Task',
      // Sprint 30 change request (story-152 QA re-review, Bug #1). These 2 rows were still live
      // in `web/i18n-guard-baseline.json` after the sprint's own pass — a ternary shape the
      // guard's own extended detector newly tracks, but never actually fixed.
      orderNow: 'Order Now',
      orderAction: 'Order',
      assigned: 'Assigned',
      // Sprint 30 change request (story-152 QA re-review, Bug #1). `deadlineLabel` and the
      // expanded-view status paragraph were entirely hardcoded English sentences built as
      // template literals with interpolation — the guard's disclosed blind spot #2 ("a literal
      // English fragment alongside a real interpolation"). Each count/branch is its own full
      // catalog string per house style §10.5's phrase-ownership rule and §11.1's ratified
      // `xOne`/`xOther` shape — not a shared template with a pluralization suffix bolted on.
      overdueByOne: 'Overdue by {n} working day',
      overdueByOther: 'Overdue by {n} working days',
      orderToday: 'Order today',
      daysLeftOne: '{n} working day left',
      daysLeftOther: '{n} working days left',
      statusOverdueOne:
        'This material order is {n} working day overdue. Order immediately to avoid task delays.',
      statusOverdueOther:
        'This material order is {n} working days overdue. Order immediately to avoid task delays.',
      statusUrgentOne: 'Only {n} working day remains to place this order. Act soon to meet the task schedule.',
      statusUrgentOther:
        'Only {n} working days remain to place this order. Act soon to meet the task schedule.',
      statusUpcomingOne: '{n} working day until the order deadline. Plan your purchase.',
      statusUpcomingOther: '{n} working days until the order deadline. Plan your purchase.',
    },
    dashboard: {
      inCatalog: 'in catalog',
      needReorder: 'need reorder',
      inventoryValueSuffix: 'inventory value',
      forActiveTasks: 'for active tasks',
      stockByCategory: 'Stock by Category',
      noStockData: 'No stock data available',
      viewAll: 'View all',
      order: 'Order',
      onHandSuffix: 'on hand',
      reorderColon: 'Reorder:',
      noLowStockAlerts: 'No low stock alerts',
      recentTransactions: 'Recent Transactions',
      viewAllTransactions: 'View all transactions',
      date: 'Date',
      typeColumn: 'Type',
      noRecentTransactions: 'No recent transactions',
      currentStockLevels: 'Current Stock Levels',
      category: 'Category',
      onHand: 'On Hand',
      available: 'Available',
      noStockLevelsAvailable: 'No stock levels available',
      showing10Of: 'Showing 10 of',
      materials: 'materials',
    },
    // Sprint 30, story-152. Mobile-only field labels per house style §12.5, reused verbatim by
    // web's MaterialCatalogFormModal (mirrors CreateMaterialModal's fields exactly — carries no
    // distinct new vocabulary of its own, per docs/ux/story-152-design.md).
    forms: {
      // Sprint 30, story-152 review Critical #4-7. `MaterialCatalogFormModal`-specific strings
      // that sat in ternary/template-literal shapes the guard's detectors can't reduce to a
      // single StringLiteral, or under a prop name (`error`) outside `JSX_PROP_LIST` — invisible
      // regardless of content.
      editMaterialTitle: 'Edit Material',
      addMaterialTitle: 'Add New Material',
      saveChanges: 'Save Changes',
      addMaterial: 'Add Material',
      autoGeneratingSku: 'Auto-generating...',
      typeNameFirst: 'Type name first',
      costCalculatedFromTransactions: 'Cost is calculated from transactions',
      yourPurchaseCost: 'Your purchase cost',
      chooseWarehouseForStock: 'Choose where this stock is held',
      // Found via a manual re-read of this file per the review's own Suggestion #1, using the
      // now-extended guard to confirm: 2 more ternary-shaped hardcoded strings, same blind spot.
      customSkuHint: 'Custom SKU — click refresh to auto-generate',
      autoGeneratedFromNameCategory: 'Auto-generated from name & category',
      marginNotCalculable: '-- (set prices to calculate)',
      basicInformation: 'Basic Information',
      nameRequired: 'Name *',
      exampleMaterialName: 'e.g., Portland Cement',
      skuInternalCode: 'SKU (Internal Code)',
      regenerateSku: 'Regenerate SKU',
      selectCategoryPlaceholder: 'Select category...',
      defaultSupplier: 'Default Supplier',
      exampleSupplierName: 'e.g., Holcim',
      additionalDetailsMaterial: 'Additional details about this material...',
      unitsAndMeasurement: 'Units & Measurement',
      system: 'System',
      metricImperialPlaceholder: 'Metric/Imperial',
      defaultUnit: 'Default Unit',
      selectUnitPlaceholder: 'Select unit...',
      pricing: 'Pricing',
      defaultCostPerUnit: 'Default Cost per Unit',
      defaultPricePerUnit: 'Default Price per Unit',
      priceChargedToClients: 'Price charged to clients',
      estimatedMargin: 'Estimated Margin:',
      stockAlerts: 'Stock Alerts',
      alertBelowQuantity: 'Alert when stock falls below this quantity',
      suggestedOrderQty: 'Suggested Order Qty',
      suggestedQtyHelp: 'Suggested quantity to order when low',
      leadTimeDays: 'Lead Time (Days)',
      leadTimeHelp: "Days needed to order before it's needed on-site",
      initialStock: 'Initial Stock',
      initialStockHelp:
        'If you already have stock of this material, you can add the initial quantity here. This will create a "Receive" transaction automatically.',
      initialQuantity: 'Initial Quantity',
      selectWarehouseHelp:
        'Select the warehouse holding this stock. It is no longer chosen for you — stock filed under the wrong warehouse looks missing when you add it to a task.',
      activeStatus: 'Active Status',
      inactiveHelp: "Inactive materials won't appear in selection lists",
    },
    equipmentDetail: {
      updatedSuccess: 'Equipment updated successfully',
      updateFailed: 'Failed to update equipment',
      checkedOutSuccess: 'Equipment checked out successfully',
      checkoutFailed: 'Failed to checkout equipment',
      returnedSuccess: 'Equipment returned successfully',
      returnFailed: 'Failed to return equipment',
      reservedSuccess: 'Equipment reserved successfully',
      reserveFailed: 'Failed to reserve equipment',
      reservationCancelledSuccess: 'Reservation cancelled successfully',
      cancelReservationFailed: 'Failed to cancel reservation',
      setMaintenanceSuccess: 'Equipment set to maintenance',
      setMaintenanceFailed: 'Failed to set maintenance status',
      completeMaintenanceSuccess: 'Maintenance completed - equipment is now available',
      completeMaintenanceFailed: 'Failed to complete maintenance',
      notFound: 'Equipment not found',
      backToEquipment: 'Back to Equipment',
      equipmentBreadcrumb: 'Equipment',
      created: 'Created',
      checkout: 'Checkout',
      reserve: 'Reserve',
      maintenance: 'Maintenance',
      return: 'Return',
      completeMaintenance: 'Complete Maintenance',
      serialNumber: 'Serial Number',
      totalHoursUsed: 'Total Hours Used',
      costPerHour: 'Cost / Hour',
      pricePerHour: 'Price / Hour',
      currentlyInUse: 'Currently In Use',
      taskColon: 'Task:',
      projectColon: 'Project:',
      taskIdColon: 'Task ID:',
      currentlyInMaintenance: 'Currently In Maintenance',
      estimatedAvailableColon: 'Estimated Available:',
      notesColon: 'Notes:',
      sinceColon: 'Since:',
      activeReservations: 'Active Reservations',
      // Sprint 31, story-158 (house style §13.2/§13.6). `EquipmentMaintenanceModal` — the
      // `count > 1` (not `!== 1`) zero-handling bug named at this story's seven sites, fixed
      // while converting. `reserva activa`/`reservas activas` reuses the shipped adjective form.
      equipmentHasReservationsTitle: 'This equipment has active reservations',
      activeReservationOne: '{n} active reservation',
      activeReservationOther: '{n} active reservations',
      equipmentHasReservationsBody:
        "This equipment has {reservations}. They will remain active, but the equipment won't be available for checkout until maintenance is completed.",
      inUseTag: '[In Use]',
      details: 'Details',
      manufacturer: 'Manufacturer',
      model: 'Model',
      purchaseDate: 'Purchase Date',
      purchaseCost: 'Purchase Cost',
      storageLocation: 'Storage Location',
      lastMaintenance: 'Last Maintenance',
      estimatedAvailable: 'Estimated Available',
      notes: 'Notes',
      reservationCalendar: 'Reservation Calendar',
      usageHistory: 'Usage History',
      noUsageHistory: 'No usage history recorded yet.',
      taskProject: 'Task / Project',
      hours: 'Hours',
      condition: 'Condition',
      cost: 'Cost',
      user: 'User',
      inUseLowercase: 'In use',
      showing: 'Showing',
      to: 'to',
      of: 'of',
      cancelReservationTitle: 'Cancel Reservation',
      cancelReservationDescription:
        'Are you sure you want to cancel this reservation? The equipment will become available for other tasks.',
    },
    valuation: {
      totalStock: 'Total Stock',
      weightedAvgCost: 'Weighted Avg Cost',
      inventoryValue: 'Inventory Value',
      current: 'Current:',
      qtyXWac: 'Qty x WAC',
      totalConsumed: 'Total Consumed',
      wacCalculation: 'WAC Calculation',
      wacFormula: 'Weighted Average Cost = Total Purchase Value / Total Quantity Purchased',
      purchaseHistory: 'Purchase History',
      noPurchaseTransactions: 'No purchase transactions recorded',
      totalPurchased: 'Total Purchased',
      wacColon: 'WAC:',
      usageHistory: 'Usage History',
      noUsageTransactions: 'No usage transactions recorded',
      projectTask: 'Project / Task',
      costByProject: 'Cost by Project',
      quantityUsed: 'Quantity Used',
      totalCost: 'Total Cost',
      draws: 'Draws',
      inventoryValuationReport: 'Inventory Valuation Report',
      asOf: 'As of',
      exportPdf: 'Export PDF',
      totalInventoryValue: 'Total Inventory Value',
      activeCatalogItems: 'active catalog items',
      totalConsumedValue: 'Total Consumed Value',
      materialsDrawnToProjects: 'materials drawn to projects',
      equipmentAssets: 'Equipment Assets',
      assetsTotal: 'assets total',
      valuationByCategory: 'Valuation by Category',
      items: 'Items',
      pctOfTotal: '% of Total',
      totalMaterials: 'Total Materials',
      detailedInventoryBreakdown: 'Detailed Inventory Breakdown',
      clickMaterialHelp: 'Click a material to view WAC details, purchase history, and job costing',
      qtyOnHand: 'Qty On Hand',
      avgUnitCost: 'Avg Unit Cost',
      noInventoryData: 'No inventory data available',
      materialCostByProject: 'Material Cost by Project',
      totalMaterialConsumedPerProject: 'Total material consumed per project at WAC',
      totalMaterialCost: 'Total Material Cost',
      itemsSuffix: 'items',
    },
  },
  // Sprint 32, story-165. Ask-your-project assistant — docs/ux/story-165-design.md's i18n table.
  assistant: {
    navTitle: 'Assistant',
    pageTitle: 'Assistant',
    emptyStateTitle: 'Ask about your projects, roster, tasks, or incidents.',
    examplePrompt1: 'Who is on site tomorrow?',
    examplePrompt2: 'What is blocking {task}?',
    examplePrompt3: 'Which projects had accidents this quarter?',
    chatPlaceholder: 'Ask a question...',
    youLabel: 'You',
    assistantLabel: 'Assistant',
    send: 'Send',
    thinking: 'Thinking...',
    lookedAt: 'Looked at: {tools}',
    newChat: 'New chat',
    history: 'History',
    deleteConversationTitle: 'Delete this conversation?',
    deleteConversationBody: "This can't be undone.",
    confirm: 'Confirm',
    dismiss: 'Dismiss',
    actionExecuted: 'Action executed: {summary}',
    actionDismissed: 'Dismissed: {type}',
    retry: 'Retry',
    actionAddNote: 'Add note',
    actionReportIncident: 'Report incident',
    actionChangeTaskStatus: 'Change task status',
    actionAcknowledgeIncident: 'Acknowledge incident',
    actionShiftTask: 'Shift task',
    actionAssignCrewToTask: 'Assign crew to task',
    actionAssignEmployeeToCrew: 'Assign employee to crew',
    errorNotConfigured: "The assistant isn't available right now.",
    errorBusy: 'The assistant is still working on your last message.',
    errorDailyMessageCap: "Your organization has reached today's message limit. Try again tomorrow.",
    errorMaxTurns: 'This conversation has reached its limit. Start a new chat to keep going.',
    errorNotFound: "That conversation couldn't be found.",
    errorNoPendingAction: "There's nothing to confirm right now.",
    errorActionStale: "This changed since it was proposed, so it wasn't applied. Ask again to try once more.",
    errorInvalidTimezone: "We couldn't read your device's time zone. Try again.",
    errorMessageTooLong: 'That message is too long. Try shortening it.',
    errorTimeout: 'The assistant took too long to respond.',
    errorRefused: "The assistant couldn't answer that.",
    errorTruncated: "The assistant's answer got cut off.",
    errorRateLimited: 'Too many requests right now. Try again in a moment.',
    errorUpstream: "Something went wrong on our end.",
    aboutProject: 'About: {project}',
    leaveProjectChat: 'Leave project chat',
    askAssistant: 'Ask assistant',
    askAssistantTooltip: 'Ask the assistant about this project',
    untitled: 'New chat',
    listEmpty: 'No conversations yet. Start one below.',
    listError: "Couldn't load conversations",
    welcomeTitle: 'How can I help today?',
    notFoundTitle: "That conversation couldn't be found.",
    notFoundBody: 'It may have been deleted. Start a new chat to keep going.',
    startNewChat: 'Start a new chat',
    errorUnavailable: 'The assistant is temporarily unavailable. An admin has been notified.',
  },
  // Sprint 33, story-169/170. End-of-day site report — docs/ux/story-169-design.md,
  // docs/ux/story-170-design.md.
  dailySiteReport: {
    cardTitle: 'Daily site report',
    cardDescription: 'Get an email each evening with what happened on your projects.',
    emailToggleLabel: 'Email me the daily site report',
    toggleOnToast: 'Daily report emails turned on',
    toggleOffToast: 'Daily report emails turned off',
    toggleErrorToast: "Couldn't save that — try again.",
    sendNowButton: 'Send me today’s report now',
    sendNowRemainingOne: '{n} left today',
    sendNowRemainingOther: '{n} left today',
    sendNowSending: 'Sending…',
    sendNowError: "Couldn't send that report — try again.",
    sendNowOfflineHint: "You're offline — connect to send a report now.",
    orgSectionTitle: 'Organization schedule',
    orgDisabledBanner: 'Daily reports are off for your organization until you set a timezone.',
    timezoneLabel: 'Timezone',
    sendHourLabel: 'Send at',
    saveScheduleButton: 'Save schedule',
    scheduleSavedToast: 'Organization schedule saved',
    errorInvalidTimezone: "That's not a valid timezone.",
    errorInvalidSendHour: 'Pick an hour between 12 AM and 11 PM.',
    errorNotConfigured: "Your organization hasn't set a timezone yet — ask an owner or admin.",
    errorQuotaExceeded: "You've already sent 3 reports today — try again tomorrow.",
    listTitle: 'Daily reports',
    emptyTitleGeneric: 'No reports yet',
    emptyBodyScheduled: 'Your next report arrives {when}.',
    emptyBodyNoTimezone: 'Daily reports are off for your organization. Ask an owner or admin to set a timezone in Profile.',
    triggerScheduled: 'Scheduled',
    triggerManual: 'Manual',
    statusPending: 'Pending',
    statusSent: 'Sent',
    statusFailed: 'Failed',
    statusSkippedEmpty: 'Skipped — nothing to report',
    statusSkippedOptedOut: 'Skipped — email off',
    errorRowNotice: 'This report’s email failed to send: "{message}" — the content below was generated but never emailed.',
    truncatedNote: 'Showing the first {n} — some items aren’t shown.',
    notFoundTitle: 'Report not found',
    notFoundBody: "This report doesn't exist or isn't yours to view.",
    backToList: 'Back to Daily reports',
    offlineBanner: 'Offline — showing cached reports',
    offlineDetailUnavailable: "This report isn't available offline yet. Connect to load it.",
    section1Title: 'Status changes & completions',
    section2Title: 'Incidents',
    section3Title: 'Crew hours',
    section4Title: 'Notes, documents & stock',
    section4Notes: 'Notes',
    section4Documents: 'Documents',
    section4Stock: 'Stock',
    section5Title: 'Looking ahead',
    section5TitleWithDate: 'Looking ahead — tomorrow, {date}',
    lookingAheadStarting: 'Starting: {task} — {project}',
    lookingAheadDue: 'Due: {task} — {project}',
    lookingAheadPendingOne: '1 incident still pending',
    lookingAheadPendingOther: '{n} incidents still pending',
    nothingToReport: 'Nothing to report.',
    stillOnSite: 'still on site',
    adjusted: '(adjusted)',
    sendHourAriaLabel: 'Send hour',
    noteExcerptTemplate: '"{excerpt}"',
    countStatusChangesLabel: 'status changes',
    countIncidentsLabel: 'incidents',
    countDocumentsLabel: 'docs',
    countStatusChangesLabelSingular: 'status change',
    countIncidentsLabelSingular: 'incident',
    countDocumentsLabelSingular: 'doc',
    taskStatusActive: 'Active',
    taskStatusInactive: 'Inactive',
    taskStatusComplete: 'Complete',
    taskStatusRejected: 'Rejected',
    taskStatusCanceled: 'Canceled',
    taskStatusInternalApproval: 'Internal Approval',
    taskStatusClientApproval: 'Client Approval',
    taskStatusDelegationCanceled: 'Delegation Canceled',
    incidentTypeWeather: 'Weather',
    incidentTypeAccident: 'Accident',
    incidentTypeMaterialsIssue: 'Materials Issue',
    incidentTypeEquipmentIssue: 'Equipment Issue',
    incidentTypeOther: 'Other',
    incidentStatusAcknowledged: 'Acknowledged',
    txTypeReceive: 'Received',
    txTypeConsume: 'Consumed',
    txTypeAdjust: 'Adjusted',
    txTypeReturn: 'Returned',
    txTypeRecovery: 'Recovered',
    txTypeTransfer: 'Transferred',
    txTypeUseAsEquipment: 'Equipment',
    // Sprint 38, story-204/205/206/207.
    emptyBodyScheduledFallback: "Your reports arrive on your organization's daily schedule.",
    nextSendToday: 'today at {time}',
    nextSendTomorrow: 'tomorrow at {time}',
    nextSendWeekday: '{day} at {time}',
    nextSendDate: '{date} at {time}',
    errorNotEligible: 'Daily reports are not available for your account.',
    ineligibleNoRole: 'You are not a member of this organization, so there is no report to send.',
    ineligibleClientNoActivityAccess:
      'Your access does not include project activity, so daily reports are not available. Ask the project team to enable activity access.',
    ineligibleClientNoLinkedClient:
      'Your account is not linked to a client record yet, so there is nothing to report on. Contact your project team.',
    incidentTypeOtherNamed: 'Other: {type}',
    incidentReportedBy: 'Reported by {name}',
    incidentDelay: 'Delay: {n} {unit}',
    delayUnitHoursOne: 'hour',
    delayUnitHoursOther: 'hours',
    delayUnitDaysOne: 'day',
    delayUnitDaysOther: 'days',
    delayUnitWeeksOne: 'week',
    delayUnitWeeksOther: 'weeks',
    incidentOpenedToday: 'opened today',
    incidentDaysOpenOne: '1 day open',
    incidentDaysOpenOther: '{n} days open',
    pendingIncidentsTitle: 'Pending incidents',
    cardGeneral: 'General items',
    cardIncidentsBadgeOne: '1 incident',
    cardIncidentsBadgeOther: '{n} incidents',
    cardToggleAria: 'Toggle {project}',
    tableName: 'Name',
    tableHours: 'Hours',
    hoursValue: '{n} hr',
  },
  clientProgress: {
    healthOnTrack: 'On track',
    healthBehind: 'Behind schedule',
    healthNotStarted: 'Not started',
    healthComplete: 'Complete',
    healthNone: 'No tasks yet',
    tasksOfTotal: '{complete} of {countable} tasks',
    tasksOfTotalComplete: '{complete} of {countable} tasks complete',
    allComplete: 'All {n} tasks complete',
    percentComplete: '{pct}%',
    overdueOne: '{n} overdue',
    overdueOther: '{n} overdue',
    dueThisWeekOne: '{n} due this week',
    dueThisWeekOther: '{n} due this week',
    awaitingApprovalOne: '{n} awaiting your approval',
    awaitingApprovalOther: '{n} awaiting your approval',
    openIncidentOne: '{n} open incident',
    openIncidentOther: '{n} open incidents',
    tileOverdue: 'Overdue',
    tileDueThisWeek: 'Due this week',
    tileAwaitingApproval: 'Awaiting your approval',
    tileOpenIncidents: 'Open incidents',
    nextUp: 'Next up',
    milestoneStarts: 'Starts',
    milestoneDue: 'Due',
    lastActivity: 'Last activity {when}',
    lastActivityToday: 'today',
    lastActivityYesterday: 'yesterday',
    lastActivityDaysAgo: '{n} days ago',
    attentionTitle: 'Needs your attention',
    attentionApprovalOne: '{n} task awaiting your approval',
    attentionApprovalOther: '{n} tasks awaiting your approval',
    attentionIncidentOne: '{n} open incident',
    attentionIncidentOther: '{n} open incidents',
    attentionMore: '+{n} more',
    openProject: 'Open {name}',
    unavailable: "Progress isn't available right now.",
    retry: 'Try again',
    groupAwaiting: 'Awaiting your approval',
    groupInProgress: 'In progress',
    groupUpcoming: 'Upcoming',
    groupComplete: 'Complete',
    colTiming: 'Timing',
    daysLateOne: '{n} day late',
    daysLateOther: '{n} days late',
  },
  notFound: {
    code: '404',
    title: 'Page not found',
    body: "The page you're looking for doesn't exist or may have moved.",
    goToLogin: 'Go to login',
    goToHome: 'Go to home',
  },
  // Sprint 47, story-233. One shared password rule; checklist rows and validators read the same keys.
  passwordPolicy: {
    checklistTitle: 'Your password must contain:',
    length: 'At least 8 characters',
    uppercase: 'One uppercase letter (A-Z)',
    lowercase: 'One lowercase letter (a-z)',
    number: 'One number (0-9)',
    symbol: 'A symbol or space (any)',
    edges: 'No space at the start or end',
    lengthError: 'Use at least 8 characters.',
    uppercaseError: 'Add an uppercase letter.',
    lowercaseError: 'Add a lowercase letter.',
    numberError: 'Add a number (0-9).',
    symbolError: 'Add a symbol or a space.',
    edgesError: 'Remove the space at the start or end.',
    tooLong: 'Use 256 characters or fewer.',
    required: 'Enter a password.',
    confirmRequired: 'Confirm your password.',
    mismatch: 'Passwords do not match.',
  },
  // Sprint 47, story-232. One-time account setup page (/setup).
  setup: {
    title: 'Set up your account',
    subtitle: 'Choose a password to finish.',
    checking: 'Checking your link...',
    emailLabel: 'Email',
    passwordLabel: 'New password',
    confirmLabel: 'Confirm password',
    save: 'Save and continue',
    saving: 'Saving...',
    expiredTitle: 'This link has expired',
    expiredBody:
      "Setup links work for 7 days. Enter your email and we'll send you a new one.",
    usedTitle: 'This link was already used',
    usedBody:
      'If you already set your password, sign in. Otherwise enter your email for a new link.',
    invalidTitle: "This link isn't valid",
    invalidBody:
      "It may have been copied incompletely. Enter your email and we'll send you a new one.",
    emailPlaceholder: 'you@company.com',
    resend: 'Send me a new link',
    resendSentTitle: 'Check your email',
    resendSentBody:
      'If that address has an account that still needs setting up, a new link is on its way. It works for 7 days.',
    resendCooldown: 'Resend available again in {seconds}s',
    emailInvalid: 'Enter a valid email address.',
    goToSignIn: 'Go to sign in',
    verifyErrorTitle: "We couldn't check your link",
    verifyErrorBody: 'Check your connection and try again.',
    retry: 'Try again',
    doneTitle: "You're all set",
    doneBody:
      'Open the ZenHammer app and sign in with your email and the password you just chose.',
    appStore: 'Download on the App Store',
    playStore: 'Get it on Google Play',
    networkError: 'Something went wrong. Check your connection and try again.',
    rateLimited: 'Too many requests. Try again in a few minutes.',
    signInFailed: 'Your password was saved. Please sign in.',
  },
};

export default en;
